var _polygon, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2",
    cx: 249.99,
    cy: 343.72,
    rx: 246.43,
    ry: 142.28,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.87,205.83c-2.62,4.59-6.53,10.91-10.21,17.75-5.52,10.22-10.49,21.6-9.74,30l0,.85h0l-.64,12.91-.09,1.76-3-1.77L446.59,263a111.12,111.12,0,0,1-.18-42.17c2.95-16.88,14.77-35.43,24.73-36.44C480.43,183.46,484.4,194.39,477.87,205.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.73,262.54a.61.61,0,0,0,.37-.63c-3.9-31.26,9-60.08,22-70.51a.6.6,0,0,0,.1-.84.59.59,0,0,0-.84-.1c-13.3,10.6-26.45,39.91-22.5,71.6a.6.6,0,0,0,.67.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.32,225.62c-1,6.06-12,13.18-19.31,23-6.56,8.86-9.42,17.85-9.18,22.63h0l-3.66-2.11-3-1.77c-1.67-22.17,6.49-35.09,13.56-43.77a21.88,21.88,0,0,1,7.73-5.76C485.05,214,490.56,218.35,489.32,225.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.38,267.32a.61.61,0,0,0,.36-.54c.37-25.4,14.93-39.24,22.57-43a.6.6,0,0,0,.28-.8.59.59,0,0,0-.8-.27c-8.46,4.17-22.86,18.14-23.25,44.06a.61.61,0,0,0,.59.61A.7.7,0,0,0,457.38,267.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.61,255l-9.93,5.11c.84-28.37-16.54-50-24.87-61.43-8.47-11.62,4.33-17.7,14.59-12.28s18.18,18.41,20.9,34.92C68.62,235.39,66.33,250.79,65.61,255Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.55,253.9h.13a.61.61,0,0,0,.63-.6c.76-35.73-10.25-54.18-23.53-63.93a.62.62,0,1,0-.74,1c13.11,9.63,23.79,27.69,23,62.91A.63.63,0,0,0,61.55,253.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.31,220.1c.11,2,1.62,3.58,3.08,4.93s3.05,2.8,3.37,4.76c.65,4-4.17,7.35-3.36,11.27a6.23,6.23,0,0,0,3.1,3.81c1.19.73,2.5,1.22,3.76,1.83a18.88,18.88,0,0,0,1.91.56,9,9,0,0,1,5.14,2.61c2,2.43,1.58,6,2.19,9.09.74,3.72,2.81,6,7.73,8l17.59-8.87c4.48-4.14,6.34-11.5,2.66-16.74-2.21-3.15-6.6-3.75-8.68-6.89-1.87-2.82-.52-6.69-1.59-9.9s-4.27-4.44-7.32-5.13-6.36.43-9.31-.81-5.64-3.15-8.71-4.08a10.38,10.38,0,0,0-9,1.06A5.49,5.49,0,0,0,15.31,220.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.46,237.11a.5.5,0,0,0-.13-.19c-7.48-11.8-19.83-17.83-24-19a.45.45,0,0,0-.55.31.44.44,0,0,0,.31.55c4,1.1,15.46,6.68,22.83,17.53a24.69,24.69,0,0,0-19.71.74.44.44,0,0,0-.16.61.44.44,0,0,0,.35.22.43.43,0,0,0,.26-.06,23.79,23.79,0,0,1,20.11-.22,37.42,37.42,0,0,1,5.56,23.33.45.45,0,0,0,.37.48h0a.44.44,0,0,0,.48-.41A38.29,38.29,0,0,0,46.46,237.11Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 432.27,
    cy: 279.51,
    rx: 51.92,
    ry: 29.98,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 88.32,
    cy: 279.51,
    rx: 53.62,
    ry: 30.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.69,385.72l-78-45.05L24.52,405.43l78,45.05a40,40,0,0,0,27.53,4.63h0l112.16-64.76A40,40,0,0,1,214.69,385.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,338.72l77.76,44.9A40.58,40.58,0,0,0,234.67,389a39.36,39.36,0,0,0,5-.31L129.88,452.1a39.56,39.56,0,0,1-27.1-4.59L25.52,402.89l111.16-64.17m0-.58L24.52,402.89l78,45.05a39.94,39.94,0,0,0,20,5.35,39.25,39.25,0,0,0,7.55-.72h0l112.16-64.75a39.93,39.93,0,0,1-27.53-4.64l-78-45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M405.58,356.79c10.64,6.14,27.87,6.14,38.5,0s10.64-16.09,0-22.23-27.86-6.13-38.5,0S395,350.65,405.58,356.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M333.54,447.85a1.21,1.21,0,0,0-.46-.66,1.13,1.13,0,0,0,.54-.95,1.17,1.17,0,0,0-.61-1L287.5,419a1.71,1.71,0,0,0-1.64,0l-9.42,5.44a1.15,1.15,0,0,0-.61,1,1.17,1.17,0,0,0,.61,1l7.43,4.29L277,428.4a1.71,1.71,0,0,0-.55-.09,1.55,1.55,0,0,0-1.09.42l-6.67,6.67a1.1,1.1,0,0,0-.3,1,1.23,1.23,0,0,0,.85.88l11.54,3.84-10.64-1.64a1.23,1.23,0,0,0-.27,0,1.41,1.41,0,0,0-1.33.75L265,447.68a1.12,1.12,0,0,0,0,1,1.34,1.34,0,0,0,1,.67L328.26,459a1.27,1.27,0,0,0,.28,0,1.4,1.4,0,0,0,1.32-.75l3.45-7.43a1.06,1.06,0,0,0,0-1,1.23,1.23,0,0,0-.48-.48l.43-.43A1.14,1.14,0,0,0,333.54,447.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,444.92a1.27,1.27,0,0,0,.86,0,3.61,3.61,0,0,1,.24-.65,4.47,4.47,0,1,1,4.05,6.35,4.39,4.39,0,0,1-2.53-.79v.09s0,0,0,.06l-.29.64a5.2,5.2,0,0,0,2.84.83,5.3,5.3,0,1,0-4.87-7.38A4.23,4.23,0,0,0,332.29,444.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M424,399.05l36.07-20.82a1.18,1.18,0,0,0,0-2.23l-8.84-5.11a4.32,4.32,0,0,0-3.87,0l-36.07,20.83a1.18,1.18,0,0,0,0,2.23l4.42,2.55-45.26,26.13c-1.07.62-.62.83-.12,1.12s.87.55,1.93-.07l45.27-26.13,2.6,1.5A4.26,4.26,0,0,0,424,399.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M482.43,400.61l-10.61-6.38a3.78,3.78,0,0,0-3.45,0l-39.88,23a1,1,0,0,0,0,2l1.72,1L372.9,452.79l-.09-.05a2.57,2.57,0,0,0-2.05-.11c-1.74.75-5.27,2.07-7.69,1.7-3.25-.49-7.66-3.64-8.11-9.87a8.23,8.23,0,0,0-.74,9.07,17,17,0,0,0,7.15,7.73l2,1.18c2.63,1.54,5.79,3.38,7.36,4.31a5.24,5.24,0,0,0,2.15.59h1.45a5,5,0,0,1,2.15.59L380,469.6l-2.3,1.33c-1,.55-1,1.44,0,2l4.09,2.35a3.77,3.77,0,0,0,3.46,0l11.63-6.71c1-.56,1-1.45,0-2l-4.08-2.36a3.86,3.86,0,0,0-3.47,0l-2,1.18a15.61,15.61,0,0,1-1.54-.72l-1.74-1a2.22,2.22,0,0,1-1-1.58l-3.44-4.15L438,424.68l1.55.92a3.59,3.59,0,0,0,3.28-.09l39.6-22.87A1.08,1.08,0,0,0,482.43,400.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M391.47,371.67,386,368.52a2.65,2.65,0,0,0-2.39,0l-22.26,12.86c-.66.38-.66,1,0,1.38l.94.53-12.51,7.23-15.38-8.89a4.34,4.34,0,0,0-5.69,1.33L311.37,409a2.41,2.41,0,0,0-.41,2.58,1.92,1.92,0,0,0,1.83,1,4.5,4.5,0,0,0,.92-.11l48-10.65c1.66-.37,2-1.25,2.11-1.74s0-1.45-1.49-2.3l-9.13-5.27,12.51-7.22,1.14.65a2.59,2.59,0,0,0,2.39,0l22.26-12.85A.73.73,0,0,0,391.47,371.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,397.43l-27.89-16.1a3.31,3.31,0,0,0-4.36,1l-17.35,26a2.22,2.22,0,0,0-.45,1.18c0,.16,0,.77,0,.92,0,.66.62,1,1.73.72l48-10.65c.89-.19,1.34-.57,1.34-1,0-.16,0-.79,0-.95C362.8,398.24,362.47,397.82,361.8,397.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M208,428.44l41.74-24.1v48.19Zm30.25,6.75V421.68l-11.7,6.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M203.7,430.46l44.4,25.63L147,463.21ZM184.58,452.2l34.76-2-15.64-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M58.3,370.78,22.12,349.89c-1.31-.76-1.31-2,0-2.75l58.52-33.78a5.25,5.25,0,0,1,4.76,0l36.18,20.89c1.31.76,1.31,2,0,2.75L63.06,370.78A5.25,5.25,0,0,1,58.3,370.78Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,118.69a41.19,41.19,0,0,0-4.42-1c-1.13-.21-1.8.23-4.51,1.72s-3.33,2.26-3.58,3.13a1.86,1.86,0,0,0,.74,2.06,1.64,1.64,0,0,0,.45,2.78,1.48,1.48,0,0,0,.59,2.4,2,2,0,0,0,1.43,2.77,29.17,29.17,0,0,0,4.4.6Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.34,256.53a2.62,2.62,0,0,0,2.35-.32.82.82,0,0,0,.39-.75L363.19,57.67l-3.32.45L385.76,255.9A.83.83,0,0,0,386.34,256.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.74,58.41c.6-.46.51-1.07-.19-1.36a2.65,2.65,0,0,0-2.35.32.73.73,0,0,0,.19,1.36A2.62,2.62,0,0,0,362.74,58.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,50.41h.06a.38.38,0,0,0,.3-.47l-2.53-11a.4.4,0,0,0-.78.18l2.54,11A.38.38,0,0,0,346.61,50.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,44.43a14.27,14.27,0,0,1,3.78-12.37c1.53-1.43,3.11-1.88,4.42-1.44h0l28.56,8.73L372,56.86l-28.55-8.74h0C342.11,47.76,341,46.51,340.54,44.43Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,44.43a14.27,14.27,0,0,1,3.78-12.37c1.53-1.43,3.11-1.88,4.42-1.44h0l28.56,8.73L372,56.86l-28.55-8.74h0C342.11,47.76,341,46.51,340.54,44.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88,40.79a14.28,14.28,0,0,0-3.78,12.37c.92,4,4.12,5,7.14,2.18A14.32,14.32,0,0,0,380,43C379.09,39,375.89,38,372.88,40.79Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.88,40.79a14.28,14.28,0,0,0-3.78,12.37c.92,4,4.12,5,7.14,2.18A14.32,14.32,0,0,0,380,43C379.09,39,375.89,38,372.88,40.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.12,46.18a3.66,3.66,0,0,0-1,3.21c.24,1,1.07,1.3,1.85.57a3.71,3.71,0,0,0,1-3.22C375.73,45.7,374.9,45.44,374.12,46.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,62.69a2.32,2.32,0,0,0,1.45-.59,2.79,2.79,0,0,0,.6-2.78L375.07,48a.4.4,0,1,0-.78.18l2.63,11.37a2.07,2.07,0,0,1-.37,2,2,2,0,0,1-2,.22L351.4,54.68A7.24,7.24,0,0,1,347,49.93a.38.38,0,0,0-.47-.3.39.39,0,0,0-.3.48,8.06,8.06,0,0,0,5,5.33l23.11,7.06A4,4,0,0,0,375.64,62.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,133.12c.54,0,1.24-.86,1.75-1.43s1.15-1.26,1.1-1.76c-.07-.69-1-.7-1-.7a3.9,3.9,0,0,0,.48-.43c.62-.59-.49-1.41-1.48-1,0,0,.42-.25.43-.53A1.27,1.27,0,0,0,370,126c.7-.34.46-1.33,0-2.1a4.7,4.7,0,0,0-1.55.2,17.71,17.71,0,0,0,.63,8.95S369.7,133.12,370.1,133.12Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.27,129.75a14.67,14.67,0,0,0,2,.57,20.35,20.35,0,0,0,2,.39,3,3,0,0,0,1.89-.46c.61-.31,1.2-.66,1.78-1a11.69,11.69,0,0,1-1.69,1.19,3,3,0,0,1-2,.53,13.73,13.73,0,0,1-2-.45A8.6,8.6,0,0,1,364.27,129.75Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.91,127.76a15,15,0,0,1-1.74.76,2.52,2.52,0,0,1-1,.16,9.19,9.19,0,0,1-.94-.19,37.42,37.42,0,0,1-3.59-1.14c1.23.25,2.44.6,3.65.9a7.77,7.77,0,0,0,.9.21,2.53,2.53,0,0,0,.89-.13C369.72,128.17,370.31,127.94,370.91,127.76Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,126a3.69,3.69,0,0,1-1.74.38,11.76,11.76,0,0,1-1.72-.48,34.72,34.72,0,0,1-3.29-1.32c1.14.31,2.25.71,3.37,1.08a15.19,15.19,0,0,0,1.66.53A4.45,4.45,0,0,0,370,126Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,94.63c-4.94,10.58-7.1,14.9-7.1,14.9s-18.93,8.65-19.46,8.81a6.8,6.8,0,0,1-3.77.32c-2.09-.29-3-.33-4.14.14s-4.75,1.93-5.41,2.84a19.62,19.62,0,0,0-1.79,3.55c-.62,1.3-.62,1.89.66,1.89,1.56,0,2.47-1.33,3.07-2.41a5.34,5.34,0,0,1,2.86-.78,4,4,0,0,0,.33.7h0a7.75,7.75,0,0,0,1.23,1.61l.11,1.47c.7.1,1.22.67.75,1.13a2.5,2.5,0,0,1-.48.41s1,0,1,.72a1.3,1.3,0,0,1-.21.65l.27,2.12s3.47-.25,4.75-1.58,1.19-1.72,4.67-3.16c1.08-.45,11.24-3.75,19-6,6-1.71,6.14-2.33,9-6.44,4.4-6.41,9.44-15.23,9.44-15.23v-20C412.47,81.38,410.49,83,405.05,94.63Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.53,126.21c1.11,1.48,3.69,2.19,5.68,2.09a9,9,0,0,1-5.56-.46Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.12,265.12c-.73-10.06.48-21.13-.36-36.84h0c-.07-4-.22-8.34-.49-12.18-.91-12.89-2.89-17.3-3.08-19.79,0,0-1-24.72-1.82-52.94-.39-13.27-4.24-17.29-7.31-24.34H412.52c-4.08,17.39-5.25,55.31-5.12,73.23.06,9.13,3.75,58,3.82,59.13.26,4-.09,5.56-1.65,7.24-3.27,3.51-8,6.86-12.12,9.92.59,1.57,5.53,1.51,8,.31a61.2,61.2,0,0,0,9.1-5.8c3.38-2.5,7.68-4.5,7.74-8.29a4.87,4.87,0,0,1,.11-.68c.07-2.22,5.23-34.91,5.66-42.5.37-6.52-.42-17.59-.42-17.59l4.21-27.63s3.23,21,5.85,32.13c2.14,9.08,5.66,24.57,8.07,35.74h0c2.31,12.87,5.62,25.38,6.21,31.82.17,1.54,1.91,16.64,2.63,20.09s8.26,3.55,8.74-2.39C463.65,279.8,462.26,267,462.12,265.12Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,272.56a3.25,3.25,0,0,0,.57,3.28,14,14,0,0,0,10.2,2.44c5.08-.61,7.84-2.15,9.89-3.82s4.92-4,7.22-4.53a13.66,13.66,0,0,0,5.15-2c.69-.65.62-3.58.62-3.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.48,253s.38,0,.5.69.29,3.16.62,4.49a24,24,0,0,1,.42,7.12c-.3,1.5-3.78,2.5-6,3.32a28.52,28.52,0,0,0-7.25,4.47A20.88,20.88,0,0,1,400,277c-5,0-8.3-1.38-9.29-3.21-1.23-2.25-.23-3.54,5.59-6.17,1.11-.5,5-2.74,6.31-3.55a29.77,29.77,0,0,0,4-2.9,20.89,20.89,0,0,0,1.79-1.73,8.29,8.29,0,0,0,1.49-1.86c.07-.15.11-.33.17-.49a8.32,8.32,0,0,0,.4-1.35c.09-.49.16-1.19.62-1.47a3.76,3.76,0,0,1,2.08-.22,14,14,0,0,1,2.23.34c.85.2,1.84.28,2.34,1.09a4.25,4.25,0,0,1,.45,2.11c0,.33,0,.68,0,1,0,.15-.06.41.14.35s.42-.56.49-.73c.17-.38.27-.78.45-1.15a6,6,0,0,1,.74-1.22,5.78,5.78,0,0,1,.92-.93,11.44,11.44,0,0,0,1-.63A2.46,2.46,0,0,0,422.48,253Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.38,268c7.31.58,9.56,5.12,9.84,7.92a17.14,17.14,0,0,1-5.2,1c-5,0-8.51-1.38-9.5-3.21C389.36,271.64,390.18,269.94,395.38,268Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.34,268.22a.29.29,0,0,0,.22-.07.36.36,0,0,0,.06-.51A8.61,8.61,0,0,0,400,265a.35.35,0,0,0-.32.39.36.36,0,0,0,.39.32,7.92,7.92,0,0,1,5.95,2.41A.34.34,0,0,0,406.34,268.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,266.42a.33.33,0,0,0,.23-.07.37.37,0,0,0,.06-.51,8.6,8.6,0,0,0-6.58-2.67.35.35,0,0,0-.32.39.35.35,0,0,0,.39.32,7.94,7.94,0,0,1,6,2.41A.34.34,0,0,0,409.5,266.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.44,264.36a.34.34,0,0,0,.23-.08.35.35,0,0,0,.05-.5,8.55,8.55,0,0,0-6.58-2.67.35.35,0,0,0-.32.39.37.37,0,0,0,.39.32,8,8,0,0,1,6,2.41A.37.37,0,0,0,412.44,264.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.32,262.3a.35.35,0,0,0,.22-.08.35.35,0,0,0,.07-.5c-1.38-1.78-4.53-3-7.19-2.72a.36.36,0,0,0-.32.39.35.35,0,0,0,.39.32c2.39-.23,5.33.87,6.55,2.45A.37.37,0,0,0,415.32,262.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.22,288.85c.2,3.44.73,5.73,2,7.75a5.06,5.06,0,0,0,5.86,2.06c2.34-.59,5.33-2.17,6-5.14a18.84,18.84,0,0,0,.53-8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,263.89c1,.08,1.25,4.7,1.8,9.34.6,5,2.08,7,2.61,11.09.61,4.65-.16,6.73-1.79,9.54s-7.4,5.58-10.25,1.55c-2.32-3.29-2.41-6.93-2.2-11.57a102.31,102.31,0,0,0-.31-11.78c-.19-3.48-1-7-.12-7.38.06.51.12,1.16.19,1.66a8.93,8.93,0,0,0,.31,1.86c.1.26.32.53.4.11a2.82,2.82,0,0,0,0-.87c-.14-1.28.51-1.38.86-1.48a41.29,41.29,0,0,1,4.46-.64c.74-.05,3.28-.16,3.61.26a2.93,2.93,0,0,1,.32,1.35c.08.7.24,1.21.27,1,0-.5-.06-1.8-.07-2.12s-.06-.71-.06-1S462.06,264.19,462,263.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.72,287a11.72,11.72,0,0,1-1.8,7.07c-1.63,2.81-7.87,5.58-10.71,1.55a13.15,13.15,0,0,1-2-6.79C453.92,285.74,464,284.37,466.72,287Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.32,283.79l.12,0a16.42,16.42,0,0,1,8.83-.85.36.36,0,0,0,.16-.7,16.77,16.77,0,0,0-9.3.91.36.36,0,0,0,.19.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.05,279.43a.33.33,0,0,0,.3-.24.34.34,0,0,0-.22-.45c-4.32-1.47-9.11.73-9.29.82a.37.37,0,0,0-.15.49.38.38,0,0,0,.49.15s4.7-2.15,8.72-.79A.26.26,0,0,0,463.05,279.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.9,276.16a.35.35,0,0,0,.08-.69,12.64,12.64,0,0,0-9.46.8.36.36,0,0,0,.37.61s4.43-2.32,8.85-.74A.3.3,0,0,0,462.9,276.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.66,272.94a.36.36,0,0,0,.09-.69c-4.45-1.66-9.34.79-9.52.9a.36.36,0,0,0-.13.49.35.35,0,0,0,.48.13c.05,0,4.79-2.4,8.92-.85A.31.31,0,0,0,462.66,272.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,119.15c4.33,7.89,7.54,14.34,8,37.81s1,34.69,1.1,37.52,1.74,7.89,3.18,21.83.12,30.27.12,30.27-1.38,2.53-6.71,3c-4.92.44-7.35-1.41-7.35-1.41s-6.75-27.15-8.61-35.54S431.82,172,431.82,172l-3.22,22.4s1.5,7.69,0,19.91S424.46,239,424.46,239a22.09,22.09,0,0,1-7.55,1.23,12.74,12.74,0,0,1-6.63-1.73s-4.18-36.37-4.18-50.23,1.17-48.5,5.53-69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.63,197s-2.7-2.82-7.9-2.19-7.31,3.68-7.31,3.68C444,196,453.63,197,453.63,197Zm-12.23,2.5c3.06.61,6.11.88,12.82-.45C451,198.25,441.4,199.47,441.4,199.47Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.65,192.38c-1.92-1.11-9-2.55-13.52-1.95l0,1.5A65.69,65.69,0,0,1,419.65,192.38Zm-13.4,1.5.08,1.41s7.14-.37,10.14-1.17C411.36,193.72,406.25,193.88,406.25,193.88Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.88,205.32c-.18-.81-.34-1.57-.5-2.3-1.35-6.48-2-19.61-1.95-30.35,0-3.24,0-6.6,0-10.16-.12-14-1.2-29.63-8.27-39.73l-.57.4c4.75,6.79,6.75,16.18,7.59,25.87-7-.93-8.56-7.86-10.65-17.41-.29-1.3-.58-2.65-.9-4l-.68.15c.32,1.39.62,2.73.9,4,2.09,9.53,3.75,17.07,11.38,18,.34,4.27.47,8.58.51,12.75,0,3.56,0,6.91,0,10.15,0,10.78.6,23.94,2,30.49.16.73.32,1.5.5,2.31,1.81,8.38,4.54,21,3.18,42.87a6.21,6.21,0,0,0,.73-.47C462.4,226.18,459.69,213.68,457.88,205.32Zm-44.87-66c1,4.61,8.34,8.49,11.68,9.29l.85,4.7c-.17,2.49-.35,5.11-.53,7.82-1,14.9-2.07,30.32-1.31,33.79,2,9.16,1.42,15,.34,25.5-.11,1.08-.23,2.2-.34,3.39-.61,6.12-1.29,12.12-1.73,16l.72-.17c.44-3.86,1.1-9.74,1.7-15.73.12-1.19.23-2.31.34-3.39,1.09-10.61,1.68-16.45-.35-25.72-.74-3.38.36-19.43,1.32-33.6.12-1.72.24-3.4.35-5l3,16.52-.43,21.76,3.22-22.4-4.39-26.64S418.16,144.67,413,139.29Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.24,135.41c-1.64-7.49-3.7-15.88-3.93-17.52-1.28-9.54.42-14.37,1-18.55,1.36-9.08-1.24-16.69-3.36-18.48,0,0-2.2-.5-4.82-1.13a39.94,39.94,0,0,0-4.53-.81,53.62,53.62,0,0,0-12.13-.33c-1,.1-5.65.9-5.65.9-1.42.33-4,.8-4,.8a29.8,29.8,0,0,0-6.24,8c-2.31,4.12-3.62,7.56-4,16.38-.51,11.23-.72,24.74-.72,32.58C418.17,143,445.56,145.39,457.24,135.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.27,70.7c-.27.72-1-.07-1.63.39a2.38,2.38,0,0,1-1.8,0c-.33-.07-.65-.17-1-.27a15.4,15.4,0,0,1-4.64-2.68c-2.11-1.68-4-3.64-5.92-5.51a76.75,76.75,0,0,1-5.53-5.59c-.82-1-4.08-4-5.22-6.09-1-1.84-.59-3.56.28-4.22-2.37.6-3.84-.86-3.89-2.14a3.12,3.12,0,0,1,2.17-2.89,1.07,1.07,0,0,0,.54,1.42,1.49,1.49,0,0,0,1.57-.35,2.44,2.44,0,0,0,.65-1.55,3.87,3.87,0,0,0-.45-2,2.76,2.76,0,0,1,.72-3.16c.6-.44,1.58-1.09,5.8-.59a1.45,1.45,0,0,0,1.37-.54,3.79,3.79,0,0,0,.35-.94,3.08,3.08,0,0,1,2.51-1.86,6.33,6.33,0,0,1,3.2.51,6.66,6.66,0,0,0,2.35.65c1.13,0,2.17-.73,3.3-.71,2.09,0,2.58,2.2,4.58,2.83,1,.31,2.18-.42,3.63,1.25.62.72.35,1.86.8,2.69a4.94,4.94,0,0,0,1.37,1.44,3,3,0,0,1-.27,4.6c1.81.59,3.6,2.7,3.78,6.31a19.17,19.17,0,0,1-1.42,7.2C447.57,60.89,442,68.8,441.27,70.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.17,76.15c0-1.49.19-9,.19-9,.06.56,2.78,2.07,5.19-.81s2.58-5.94,1.12-7.88c-1.61-2.15-5.81-2.1-6.21,1.54-2.09-.08-3.09-1-2.27-4.42-.22-2.4-2.94-3.1-2.87-8.34-6.86-4.53-13.81-4.2-18-.6a40.57,40.57,0,0,0-1.64,13.18c.3,7.93,2.43,11.74,5,13.07,1.7.89,3.24,1.1,6.21.85l-.14,2.49h0c-.05,1.24.06,2.17-1.15,2.58-.81.27-2.74.64-2.74.64s-2.82,4.87,4.95,5.31c12.39.69,17.36-5.07,17.36-5.07l-2.75-.84C441.4,78.26,441.19,77.63,441.17,76.15Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.33,64.39l-4.68,1.51a2.41,2.41,0,0,0,3.05,1.67A2.57,2.57,0,0,0,430.33,64.39Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,65.48a2.71,2.71,0,0,0-2.7,2.11,2.29,2.29,0,0,0,1.37,0,2.54,2.54,0,0,0,1.7-2A2.21,2.21,0,0,0,430,65.48Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,53,422,51.31a1.62,1.62,0,0,0-2.24-.69A1.77,1.77,0,0,0,419.07,53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.18,53.18l-3.25-1A1.63,1.63,0,0,1,432,51,1.8,1.8,0,0,1,433.18,53.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,55.85a1.44,1.44,0,0,1-1.28,1.53,1.36,1.36,0,0,1-1.51-1.24,1.45,1.45,0,0,1,1.29-1.53A1.35,1.35,0,0,1,422.41,55.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.56,56.07a1.43,1.43,0,0,1-1.29,1.53,1.35,1.35,0,0,1-1.5-1.23,1.45,1.45,0,0,1,1.29-1.53A1.35,1.35,0,0,1,432.56,56.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.29,60.3l4.43,2.1.89-8.53C424.84,53.91,423.07,56.84,421.29,60.3Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.89,73.78c5.32-.55,10.41-2.3,11.6-4.73A6.35,6.35,0,0,1,437.36,73c-3.55,3-9.58,2.69-9.58,2.69Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.61,147.9c2.24.64,5.12-2.15,5.9-3.12s-.22-3.28-.7-5.22,0-5.24-2.4-4.32S454.93,142.66,459.61,147.9Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,80.86c6.24.93,9.14,2.42,12.57,9.33,4,8,10.49,19.24,11.49,22.73.93,3.25,2.79,5.57-.77,10.51-3.26,4.52-13.48,16.37-15,18.11-1.33,1.54-.6,5.94,4,5.29,0,0-3.47,3.08-5.39,2.73-1.64-.29-4.24-1.73-6.62-6.74-1.5-3.15-.24-5.63,2-9.14,2.73-4.19,8.62-15.89,8.62-15.89L451.38,99.07S445.67,86.41,451,80.86Z",
    style: {
      fill: "#ffbda7"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.47,254.33l-1.39-12.91,14.78,1s-.23,7-.43,11c-.12,2.34,3,6.69,3,6.69s-7,3.73-10.67,2.42-5.68-5.93-5.63-6.94S98.47,254.33,98.47,254.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.06,274.5a3.24,3.24,0,0,1-.63,3.44c-1.44,1.2-5.7,3.21-11.38,2.62s-8.78-2.18-11.08-3.91-5.52-4.19-8.09-4.68a16.26,16.26,0,0,1-5.77-2.09c-.77-.68-.72-3.74-.72-3.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,254.31a.89.89,0,0,0-.84.73c-.16.84-.31,3.3-.67,4.7a23.38,23.38,0,0,0-.43,7.45c.34,1.56,4.24,2.59,6.73,3.43a31.88,31.88,0,0,1,8.12,4.61c2.7,2,8.34,4.06,12,4,4.37-.11,9.27-1.51,10.37-3.43,1.36-2.37,2.33-5.12-4.2-7.82-1.24-.51-5.59-2.82-7.07-3.66-4-2.28-6.84-4.38-8.74-8.49a2.3,2.3,0,0,0-1-1.25,2.19,2.19,0,0,0-1.27-.08,46.28,46.28,0,0,0-6.35,1.24c-.86.4-2.09.88-2.06,1.92a3.26,3.26,0,0,0,.27,1.05c.08.22.14.5,0,.63s-.44,0-.61-.15a16.22,16.22,0,0,1-1.78-1.93,6,6,0,0,0-1-1,11.35,11.35,0,0,1-1.12-.66C98.4,255.25,98.49,254.79,98.46,254.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.37,275.23c-1.14-.85-2.36-1.67-3.57-2.41h0s7.69,4.21,10.74,2.18c2-1.3,1-2.82.94-3.31s6.9-4.09,8.82-4.34h0c.54.27,1,.49,1.28.6,6.53,2.7,5.56,5.45,4.2,7.82-1.1,1.92-4.64,3.46-10.29,3.55C119.79,279.39,114.07,277.24,111.37,275.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,270.26c4.06,1.44,2.35,2.17,1.23,2.34s-8-3.42-12.17-6.41c-4.37-3.12-7.14-6.57-8.77-7.72-.6-.43-1.25-1-1.83-1.44.09-.84.16-1.59.24-2a.89.89,0,0,1,.84-.73c0,.48-.06.94.34,1.3a11.35,11.35,0,0,0,1.12.66,6,6,0,0,1,1,1,16.22,16.22,0,0,0,1.78,1.93C106.34,263.28,114.87,268.82,118.92,270.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85,272.05a.38.38,0,0,1-.25-.08.35.35,0,0,1-.07-.52c1.12-1.32,6.46-4.51,9.43-4.26a.38.38,0,0,1,.36.41.39.39,0,0,1-.43.34c-2.78-.23-7.85,2.92-8.73,4A.41.41,0,0,1,119.85,272.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,270.09a.44.44,0,0,1-.25-.08.36.36,0,0,1-.07-.53c1.12-1.32,6.46-4.5,9.43-4.25a.38.38,0,0,1,.36.4.39.39,0,0,1-.43.34c-2.78-.22-7.85,2.93-8.73,4A.41.41,0,0,1,116.3,270.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,268.23a.38.38,0,0,1-.25-.08.35.35,0,0,1-.07-.52c1.12-1.33,6.46-4.52,9.43-4.26a.38.38,0,0,1,.36.41.39.39,0,0,1-.43.34c-2.78-.24-7.85,2.92-8.73,4A.41.41,0,0,1,112.75,268.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.46,266.1a.43.43,0,0,1-.26-.09.35.35,0,0,1-.06-.52c1.11-1.32,6.47-4.51,9.43-4.25a.37.37,0,0,1,.36.4.39.39,0,0,1-.43.34c-2.78-.23-7.85,2.92-8.74,4A.44.44,0,0,1,109.46,266.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,264a.38.38,0,0,1-.25-.08.35.35,0,0,1-.08-.52c1.54-1.88,7.14-4.56,10.11-4.3a.38.38,0,0,1,.37.4.4.4,0,0,1-.44.34c-2.67-.23-8,2.35-9.4,4A.4.4,0,0,1,106.23,264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.24,261.37l3.38-12.23-15.05-2.33-.67,11.84s-1.6,4.22-.68,5.78,10.91,3.32,11.85,2.3S69.24,261.37,69.24,261.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,288c-.49,3.79-1.32,6.24-3,8.27s-4.6,2.35-7.48,1.29-6.51-3.32-7.14-6.73a18.62,18.62,0,0,1,.57-9.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9,258.65c-1.21-.08-1,5.12-2,10.17-1.09,5.41-3.09,7.43-4,11.86-1.08,5.06-.92,7.41.92,10.81s8.87,7.44,12.7,3.46c3.13-3.25,3.51-7.28,3.57-12.47a115.83,115.83,0,0,1,.55-13.15c.48-3.83,1.64-7.23.63-7.81-.12.56-.24,1.27-.36,1.81s-.35,2.5-1,2.43a7.15,7.15,0,0,1,.07-1.46,1.65,1.65,0,0,0-.25-1.29,5.58,5.58,0,0,0-1.93-1c-1.17-.37-3.27-.84-4.46-1.1-.6-.13-1.2-.24-1.8-.31a5.68,5.68,0,0,0-1.54,0,.94.94,0,0,0-.68.44,1.39,1.39,0,0,0-.1.58,4,4,0,0,1-.22,1c-.05.14-.18.31-.35.25a.31.31,0,0,1-.18-.33c0-.63.15-1.07.23-1.79,0-.33.13-.78.15-1.12S56.85,259,56.9,258.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.24,279.25c-.16.73-1.18,5.56.27,6.66s2.72-2.57,2.72-2.57,3.91-.52,9.36,2.41c-.33.76.36,3.52,1.93,3.17s2.52-5.92,2.53-6c-.08,5-.52,8.86-3.56,12-3.83,4-10.85-.06-12.7-3.46s-2-5.75-.92-10.81C51,280.17,51.11,279.7,51.24,279.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.65,283.73c-.14,1.86-2.18.95-2.1-1.7s2.09-8.68,2.36-13.21c.44-6.22.78-10.25,2-10.17,0,.06,0,.12,0,.19l-.32,2.59a9.34,9.34,0,0,0-.14,1.11c-.27,3.8-.42,11.19-1,14.62A52.92,52.92,0,0,0,54.65,283.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,285.61a53.08,53.08,0,0,0,1.56-6.39c.63-3.39,2.76-10.17,3.81-13.82a8.09,8.09,0,0,0,.56-2.07c.11-.51.22-1.15.33-1.69l0-.11c.74.42.44,3.37,0,4.89s-.92,3.15-1.44,5.33c-1.31,4.3-1.52,10.78-2.36,13.25S62.44,287.39,63,285.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7,285.92a.52.52,0,0,1-.16-.06,16.45,16.45,0,0,0-9.22-2.12.49.49,0,0,1-.52-.36.35.35,0,0,1,.34-.44A17.38,17.38,0,0,1,64,285.21a.39.39,0,0,1,.15.56A.41.41,0,0,1,63.7,285.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,282a.47.47,0,0,1-.15-.06,20.44,20.44,0,0,0-10.32-2.37.48.48,0,0,1-.51-.37.36.36,0,0,1,.36-.43,21.21,21.21,0,0,1,10.91,2.51.4.4,0,0,1,.17.56A.43.43,0,0,1,65,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,275.78a.5.5,0,0,1-.37-.32A.37.37,0,0,1,55,275c5.49-.88,10.67,2.28,10.89,2.42A.4.4,0,0,1,66,278a.48.48,0,0,1-.62.08s-5.08-3.1-10.19-2.27A.6.6,0,0,1,55,275.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,272.19a.48.48,0,0,1-.35-.31.36.36,0,0,1,.3-.47,16,16,0,0,1,11.11,2.41.39.39,0,0,1,.12.57.47.47,0,0,1-.62.05,15.23,15.23,0,0,0-10.36-2.24A.67.67,0,0,1,55.56,272.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.19,268.16a.46.46,0,0,1-.36-.3.37.37,0,0,1,.29-.48c5.68-1.08,11,2.39,11.19,2.54a.38.38,0,0,1,.13.56.45.45,0,0,1-.62.06s-5.16-3.38-10.43-2.37A.44.44,0,0,1,56.19,268.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,132.19C63.27,162.19,62,203.3,62,203.3c-.25,2.27-1.89,6.16-3.16,17.39-1.34,11.85-1.38,28.61-1.38,28.61s7.89,4.58,14.49,2.46c0,0,6.55-26.25,10.16-40.18,3.41-13.18,8.22-33.27,8.22-33.27l3.56,20s-.6,8.55-.46,14.55c.17,7,4.07,33.7,4.07,33.7s7.77,5.23,14.67,0c0,0,2-39.08,2.39-47.45.66-16.44.54-48.34.32-69.58Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,132.19C63.27,162.19,62,203.3,62,203.3c-.25,2.27-1.89,6.16-3.16,17.39-1.34,11.85-1.38,28.61-1.38,28.61s7.89,4.58,14.49,2.46c0,0,6.55-26.25,10.16-40.18,3.41-13.18,8.22-33.27,8.22-33.27l3.56,20s-.6,8.55-.46,14.55c.17,7,4.07,33.7,4.07,33.7s7.77,5.23,14.67,0c0,0,2-39.08,2.39-47.45.66-16.44.54-48.34.32-69.58Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,178.31,94,157s8-1,12.1-4.72c0,0-2.71,4.92-10.23,6.72l-3.7,19.4,1.65,19.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.25,249.63c1.6,2.27,8.87,4.63,14.77,2.69l1.1-4.6c-4.46,1.35-12.13-.14-15.7-3.12Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.42,247.25c2,1.94,9.33,3,14.82.05l.31-4.73c-4.17,2.13-11.76,2.12-15.77-.18Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.28,72.14c6.41,1,7.51,2.62,17,10.81a69.63,69.63,0,0,0,13.64,9.53s8,9.75,8.35,11.65,1,6.18-2.79,8.57c-2.41,1.52-5.21.13-6.7.27-3.11.3-5-2.23-6.32-3-8.76-5.21-17.55-10-17.55-10Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.82,66.7c-1.31-.77-1.54.44-2,.6,0,0,1.35-1.55-.92-2.89-1.39-.83-2.07,1.12-2.1.86s1.68-4.09,3.06-7.46c1.31-3.21.18-4.12-.35-4.37s-1.05,0-2.26,2.29-4.78,9.3-5.58,10.75-1.39,2.13-1.91.25-.92-3.45-2-4.52c-1.72-1.81-3.06-1-2.79.37.39,2,.36,4.23.63,7.41.15,1.66.19,3.22.38,4.36.58,4-1.75,5.82-4.53,9-2.27,2.57-4.61,4.67-9.82,9.82-4.95,4.88-4.75,16.37.13,18.4,5.61,2.32,7.84-.63,11.91-6.84,3.44-5.26,8.2-14.85,9.48-17.07S158,84.05,159.76,83a13,13,0,0,0,4.86-5.42c.64-1.12,1.87-3.18,2.66-4.85s.88-2.86-.07-3.58c-1.3-1-1.68.48-1.82.32S166.69,67.81,164.82,66.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.77,69.46c1.82,1.78,3.1,6.6,2.32,9.78C159.36,75.91,158.07,71,154.77,69.46Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,66.31c-1.06,2-2.08,4.12-1.81,5s.9,1.33,1.62,1.14a2.66,2.66,0,0,0,1.14-.62,2.31,2.31,0,0,0-.27,1.53,1.64,1.64,0,0,0,1.85.83,2.23,2.23,0,0,0,1.07-.9s-.44,1.16,0,1.8a1.48,1.48,0,0,0,2.26-.19c-.53.92-1.28,1.44-2.23,1s-.72-1.21-.72-1.21a1.64,1.64,0,0,1-1.85,0,1.68,1.68,0,0,1-1-1.78A1.57,1.57,0,0,1,157,72c-.42-1.2,0-2.07.78-3.47A10,10,0,0,1,159.39,66.31Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-2",
    d: "M79.76,70.14c-3,.63-6.86,1.41-10.71,2.48a39.5,39.5,0,0,0-9.9,3.68,156.87,156.87,0,0,0,2.93,28c.66,3.07,2.89,11.54,3.28,18a103.54,103.54,0,0,1-.55,20.25s10,7.42,31.37,5.81c16.78-1.26,19-7.44,19-7.44s-.3-28-.74-40.34c-.57-16.25-5.49-25.63-9.12-28.47l-11-1.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.39,35.42s-2.59.2-4.29,3.46c-.85,1.64-1.46,4.63.87,13.17a34.5,34.5,0,0,0,4.11,9.43,4.26,4.26,0,0,0,2.46,2l-.17-6.57-.25-4.57s3.69-3.35,4-6.64A10.5,10.5,0,0,0,80.89,39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,35.64c.64-3.69,5.32-8.1,14.36-8.58,7.4-.4,11.73,2.15,14.31,6.47s.87,9.9.87,9.9L80.78,41.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.36,58.79c3.41,1.66,5-1,5-1l.51,13.54c6.53,8.75,24,5.59,16.82-1l0-3.09a20.55,20.55,0,0,0,3-.29c3-.48,4.91-2.87,5.8-6.13a45.55,45.55,0,0,0,0-20.78c-.35-1.58-1-3.32-2.49-4-3.62-1.78-7,.79-12,2.76-2.09.81-7.15,1.17-8.48.54,1.76,1.94,1.74,8.07-.85,10.56a5.46,5.46,0,0,1-1.3,1.69c-1.1,1-2-1.51-2.93-2.48a3.79,3.79,0,0,0-5.9,1.36A6.18,6.18,0,0,0,72.36,58.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.63,67.25a27.28,27.28,0,0,1-9.79-1.5c-2.33-1-4.4-4.14-5.08-7.27,0,2.52,1.11,7,4.64,8.85s7.66,2,10.24,2Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1,47.35c-.93,1.84.13,7.63,1.86,8.36s3.56-.46,7.49-.68a28.46,28.46,0,0,1,8.8.72c1.77.49,5,1.3,5.12-.49-.11,4.42-1,9.44-4.17,11.05s-11.42,2-15.67-.22-5-4.75-5.82-8.21a62.47,62.47,0,0,0-2.18-7.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.94,43.81l-3.34,1.4a1.9,1.9,0,0,1,1-2.43A1.77,1.77,0,0,1,88.94,43.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44,43.72,98,42.37a1.76,1.76,0,0,1,2.32-1.06A1.92,1.92,0,0,1,101.44,43.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9,48a1.48,1.48,0,1,0,1.42-1.53A1.48,1.48,0,0,0,86.9,48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.59,47.4A1.48,1.48,0,1,0,100,45.87,1.35,1.35,0,0,0,98.59,47.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,44.73l1.22,9.4,5-1.83A22.06,22.06,0,0,0,93.05,44.73Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,56.51l3.85,1.28a2,2,0,0,1-2.53,1.35A2.12,2.12,0,0,1,91,56.51Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.41,57.21a2.09,2.09,0,0,0-.49-.05,2,2,0,0,0,2,2.07A1.86,1.86,0,0,0,91.41,57.21Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm-with-scissors--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.51,147.17a39.09,39.09,0,0,1-5.68-2.92c-4.62-3.07-10.42-2.68-13.49-6.3-2.43-2.85-13.29-16.89-13.29-16.89L65.64,98.4S71,81,64.2,74.76C57.91,75.87,53.52,79,51.48,86.7c-2.09,7.87-9.3,24.68-11,31-1.56,5.63-.42,7.11,3.33,11.25,5.8,6.41,13.91,13.27,17.64,16.55,2.22,1.94,4.7,4,10.72,9.07.39.33,2,1.77,2.4,2.11l6-7.29c.19-.74,1.14-1,5.15-.12S91.67,147.6,90.51,147.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.62,73.91c-3.9.92-9.88,2-12.57,9-2.23,5.84-7.11,20-9.56,26.74-3.54,9.76-3.55,12.85-3.2,14.54s4.38,4.72,9.71,10.13c3.06-5.1,9-10,11.25-10.6L58.19,121,66.5,99.45S71.69,81,64.62,73.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.56 130.69 161.54 92.6 163.07 93.47 163.07 103.41 102.83 154.75 97.09 158.06 95.56 157.19 95.56 130.69",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.09 131.56 163.07 93.47 163.07 103.41 102.83 154.75 97.09 158.06 97.09 131.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,128.46a3.58,3.58,0,0,0-3.61,0l-14.48,8.37c-1.69,1-2,2.62-2,4.45,0,1.19.09,2.18.58,2.48l2.88,1.66c.27.15.65.11,1.2-.2v9.93l-2.87,1.66c-1.59.91-1.79,2.51-1.79,4.34,0,1.16.11,2.11.63,2.41l2.87,1.65c.3.17.73.12,1.35-.23l13.34-7.71a13.09,13.09,0,0,0,6.55-11.33v-12.7a3.55,3.55,0,0,0-1.8-3.11ZM87.8,141l4-2.32.19-.09V145a6.76,6.76,0,0,1-3,5.29L87.8,151Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.22,130.11l-14.48,8.36c-1.69,1-2,2.63-2,4.45s.2,3.2,1.79,2.29l2.87-1.66v13.24l-2.87,1.66c-1.59.91-1.79,2.52-1.79,4.35s.29,3.14,2,2.17l13.34-7.71a13.09,13.09,0,0,0,6.55-11.33v-12.7A3.6,3.6,0,0,0,95.22,130.11Zm-.33,16.53a6.77,6.77,0,0,1-3.06,5.3l-4,2.31V141l4-2.32c1.69-1,3.06-.18,3.06,1.77Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.35,128.45l-14.48,8.37c-1.69,1-2,2.62-2,4.45,0,1.19.08,2.18.58,2.48l2.83,1.63c-.46-.32-.54-1.3-.54-2.46,0-1.82.29-3.48,2-4.45l14.48-8.36a3.56,3.56,0,0,1,3.46-.09L96,128.46A3.6,3.6,0,0,0,92.35,128.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.89,140.45v6.19a6.29,6.29,0,0,1-.89,3L91.13,148a6.3,6.3,0,0,0,.9-3V138.8c0-.08,0-.14,0-.21l-.19.09C93.52,137.71,94.89,138.5,94.89,140.45Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.55 145.21 80.55 155.14 83.42 156.79 83.42 143.55 80.55 145.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,155.14l-2.87,1.66c-1.59.91-1.79,2.52-1.79,4.34,0,1.16.11,2.11.63,2.41l2.84,1.63c-.49-.31-.6-1.25-.6-2.38,0-1.83.2-3.44,1.79-4.35l2.87-1.66Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.46,165.11a2.21,2.21,0,0,1-.49.17A2.21,2.21,0,0,0,80.46,165.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.44,165.23a.14.14,0,0,1-.08,0l0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,155.14h0l-2.87,1.66A3.1,3.1,0,0,0,76.51,158l2.86,1.65a3.21,3.21,0,0,1,1.18-1.16l2.87-1.65Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,155.14h0l-2.87,1.66A3.1,3.1,0,0,0,76.51,158l2.86,1.65a3.21,3.21,0,0,1,1.18-1.16l2.87-1.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,149.65a6.31,6.31,0,0,1-2.17,2.29l-4,2.31V151l1.17-.67A6.18,6.18,0,0,0,91.13,148Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.54,146.22c0,.85,3.69,3.16,4.07,3.19a17.6,17.6,0,0,0,4.86-1c1.27-.46,2.47-.58,2.83.51,0,.62-.83,1.3-.83,1.3a2.37,2.37,0,0,1,0,1.84c-.25.62.26,1.7-1.17,3.47a16,16,0,0,1-5.51,4c-1.74.8-6.73-.29-8.48-1.36-1.31-.8-5.51-4.64-7.42-6.25S80.54,146.22,80.54,146.22Z",
    style: {
      fill: "#ffa8a7"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--architectural-plan--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--architectural-plan--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.51,453a39.69,39.69,0,0,1-19.86-5.32L25,402.89l111.66-64.46,77.88,45a40.26,40.26,0,0,0,26.32,4.91L129.94,452.36A41.4,41.4,0,0,1,122.51,453Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.51,447.59A34.32,34.32,0,0,1,105.38,443L35.92,402.9l100.76-58.18.15.09,75,43.31a46,46,0,0,0,10,4.29l.67.19L128,447.15A35,35,0,0,1,122.51,447.59ZM37.12,402.9l68.56,39.58A33.71,33.71,0,0,0,122.51,447a33.21,33.21,0,0,0,5.36-.43L221,392.78a46,46,0,0,1-9.48-4.14l-74.86-43.23Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.82 341.51 122.53 341.51 108.87 349.4 164.48 349.4 150.82 341.51",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.82 340.67 122.53 340.67 108.87 348.56 164.48 348.56 150.82 340.67",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.82 340.67 122.53 340.67 108.87 348.56 164.48 348.56 150.82 340.67",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.18 412.26 30.18 395.3 43.84 387.42 43.84 420.14 30.18 412.26",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.38 410.79 29.38 394.45 43.04 386.57 43.04 418.67 29.38 410.79",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.38 410.79 29.38 394.45 43.04 386.57 43.04 418.67 29.38 410.79",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--House--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "108.5 404.7 112.65 407.09 117.05 404.55 116.14 404.02 149.03 385.03 149.95 385.56 156.28 381.9 152.14 379.5 108.5 404.7",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.2 369.75 126.38 371.95 124.64 370.94 91.74 389.94 93.49 390.94 89.08 393.49 85.36 391.34 126.47 367.6 130.2 369.75",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.3 395.39 100.05 405.63 103.1 403.87 102.14 403.31 103.03 402.79 97.65 399.69 98.73 399.06 87.34 392.48 82.3 395.39",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.5 408.2 93.46 419.79 88.95 417.19 104.5 408.2",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,365.83a6.57,6.57,0,0,0-3.51,4.23l-2.92-1.68a15,15,0,0,1,1.66-1.11,22.36,22.36,0,0,1,7.23-2.52A12.72,12.72,0,0,0,142.9,365.83Z",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07,367.26c6.89,4,6.89,10.43,0,14.4a19.63,19.63,0,0,1-4.12,1.78l-6.82-3.94,1.8-1-.9-.52a16.77,16.77,0,0,0,7.32-2c4.59-2.65,4.81-6.89.61-9.68A17.93,17.93,0,0,1,163.07,367.26Z",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.42 380.63 109.34 399.15 93.47 389.99 125.55 371.47 141.42 380.63",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.42 380.63 109.34 399.15 93.47 389.99 125.55 371.47 141.42 380.63",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.05 397.01 121.05 392.39 128 372.89 125.55 371.47 121.28 373.94 113.05 397.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.41 374.86 129.59 373.8 123.46 391 126.23 389.4 131.41 374.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.52,400.05,91,389.94l33.64-19.42,17.52,10.11Zm-16-10.11,16,9.26,32.16-18.57-16-9.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.53,
    y: 382,
    width: 37.99,
    height: 0.74,
    transform: "translate(-176.3 107.06) rotate(-30.01)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.69,
    y: 372.43,
    width: 0.74,
    height: 19.37,
    transform: "translate(-269.89 296.77) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.73,
    y: 378.76,
    width: 0.74,
    height: 19.37,
    transform: "translate(-280.86 290.44) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.43 405.35 85.29 414.51 96.28 408.16 80.42 399 69.43 405.35",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.43 405.35 85.29 414.51 96.28 408.16 80.42 399 69.43 405.35",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.05 412.06 85.29 414.51 86.85 413.61 90.08 404.58 84.81 401.53 81.05 412.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.66 405.49 89.27 412.21 92.03 410.61 93.49 406.55 91.66 405.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.29,414.93,67.77,404.82l11.73-6.77L97,408.16Zm-16-10.11,16,9.26,10.25-5.92-16-9.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 403.2,
    width: 12.69,
    height: 0.74,
    transform: "translate(-191.55 92.85) rotate(-30.02)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.46 415.5 117.47 423.02 120.2 421.44 107.18 413.93 104.46 415.5",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.46 415.5 117.47 423.02 120.2 421.44 107.18 413.93 104.46 415.5",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.14 419.36 114.87 421.51 115.8 418.9 112.06 416.75 111.14 419.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.99 422.16 117.29 422.91 118.22 420.3 116.92 419.55 115.99 422.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.55,424l-14.41-8.32,4.76-2.74,14.41,8.31Zm-12.93-8.32,12.93,7.46,3.28-1.89-12.93-7.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.81 394.71 133.73 413.24 117.87 404.08 149.95 385.56 165.81 394.71",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.81 394.71 133.73 413.24 117.87 404.08 149.95 385.56 165.81 394.71",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.44 411.1 145.44 406.48 152.4 386.97 149.95 385.56 145.67 388.03 137.44 411.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.81 388.94 153.99 387.89 147.85 405.08 150.62 403.49 155.81 388.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.91,414.14,115.4,404,149,384.6l17.52,10.12Zm-16-10.12,16,9.26,32.16-18.56-16-9.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.93,
    y: 396.08,
    width: 37.99,
    height: 0.74,
    transform: "translate(-180.08 121.15) rotate(-30.01)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.09,
    y: 386.52,
    width: 0.74,
    height: 19.37,
    transform: "translate(-269.89 324.94) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.12,
    y: 392.85,
    width: 0.74,
    height: 19.37,
    transform: "translate(-280.86 318.6) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,427.64,114,426.52l11.67-6.74,1.94,1.12Zm-.46-1.12.46.27,10.19-5.89-.46-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6,434.17l-2.71-1.56,77.41-44.69,2.71,1.56Zm-1.23-1.56,1.23.71,75.93-43.84-1.23-.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52,406.27l-5.13-3,43.1-24.88-18-10.41-43.1,24.89-5.12-3,48.22-27.85,28.28,16.33Zm-3.64-3,3.64,2.11,46.75-27L126.47,363,79.73,390l3.64,2.1,43.1-24.88L146,378.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.37,
    y: 385.92,
    width: 0.74,
    height: 21.66,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -296.23, 280.41)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.85 403.11 96.91 399.69 139.67 375 140.04 375.64 98.39 399.69 103.22 402.47 102.85 403.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,418.54l-24-13.84,44.38-25.62,24,13.84Zm-22.5-13.84,22.5,13,42.9-24.77-22.5-13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.15 430.43 88.76 417.5 89.13 416.87 111.15 429.58 131.55 417.8 131.92 418.44 111.15 430.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.91,
    y: 393.56,
    width: 5.81,
    height: 0.74,
    transform: "translate(-185.69 95.27) rotate(-30.02)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,419.68l-25.82-14.9L79.43,393.3l25.81,14.9ZM61,404.78l24.34,14.05,18.39-10.63L79.43,394.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.58,426.49,97.8,416.22l10.07-5.81,17.78,10.26Zm-16.3-10.27,16.3,9.41,8.59-5-16.3-9.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.34,
    y: 373.07,
    width: 0.74,
    height: 23.7,
    transform: "translate(-248.99 338.57) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.58,383.9l-.37-.64a2.53,2.53,0,0,0,0-4.83l-2.43-1.4.37-.65,2.43,1.41a3.25,3.25,0,0,1,0,6.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,387.25l0-.74a7.87,7.87,0,0,0,3.65-.93l.84-.48.37.64-.84.49A8.57,8.57,0,0,1,164.92,387.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,383.79l-.22-.71a19.61,19.61,0,0,0,4-1.74c3.21-1.85,5-4.29,5-6.88s-1.77-5-5-6.87c-6.78-3.91-17.79-3.91-24.57,0a16.45,16.45,0,0,0-1.63,1.08l-.45-.58A15.4,15.4,0,0,1,138,367c7-4,18.33-4,25.31,0,3.45,2,5.35,4.66,5.35,7.51s-1.9,5.53-5.35,7.52A20.85,20.85,0,0,1,159.06,383.79Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "158.04 429.66 144.13 421.58 206.81 385.39 207.11 385.91 145.32 421.58 158.34 429.14 158.04 429.66",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.56,
    y: 405.89,
    width: 71.89,
    height: 0.6,
    transform: "translate(-178.86 144.6) rotate(-29.99)",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.07,
    y: 408.55,
    width: 72.4,
    height: 0.6,
    transform: "translate(-178.36 145.68) rotate(-29.73)",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.56,
    y: 394.95,
    width: 0.6,
    height: 5.27,
    transform: "translate(-248.88 364.06) rotate(-60)",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.68,
    y: 404.76,
    width: 0.6,
    height: 10.33,
    transform: "translate(-263.51 363.42) rotate(-60)",
    style: {
      fill: "#242424"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--house--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--house--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.74,299.4a1.54,1.54,0,0,0-.89-1.25L285,224.37a4.79,4.79,0,0,0-4.33,0L132.57,309.88a1.52,1.52,0,0,0-.9,1.25v7a1.53,1.53,0,0,0,.9,1.25l127.82,73.78a4.79,4.79,0,0,0,4.33,0l148.13-85.51a1.52,1.52,0,0,0,.89-1.25Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.74,299.4a1.54,1.54,0,0,0-.89-1.25L285,224.37a4.79,4.79,0,0,0-4.33,0L132.57,309.88a1.52,1.52,0,0,0-.9,1.25v7a1.53,1.53,0,0,0,.9,1.25l127.82,73.78a4.79,4.79,0,0,0,4.33,0l148.13-85.51a1.52,1.52,0,0,0,.89-1.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,223.85a4.34,4.34,0,0,0-2.16.52L132.57,309.88a1.52,1.52,0,0,0-.9,1.25v7a1.53,1.53,0,0,0,.9,1.25l127.82,73.78a4.34,4.34,0,0,0,2.16.52V363.94Z",
    style: {
      fill: "#242424",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.85,298.15,285,224.37a4.79,4.79,0,0,0-4.33,0L132.57,309.88a1.32,1.32,0,0,0,0,2.5l127.82,73.78a4.79,4.79,0,0,0,4.33,0l148.13-85.51A1.32,1.32,0,0,0,412.85,298.15Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.85,298.15,285,224.37a4.79,4.79,0,0,0-4.33,0L132.57,309.88a1.32,1.32,0,0,0,0,2.5l127.82,73.78a4.79,4.79,0,0,0,4.33,0l148.13-85.51A1.32,1.32,0,0,0,412.85,298.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.39,249.37,132.57,309.88a1.32,1.32,0,0,0,0,2.5L229.1,368.1l67.65-17.2L370,308.63l-87.09-50.28Z",
    style: {
      fill: "#242424",
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.88,256.66a3.54,3.54,0,0,1,2,.35,19.61,19.61,0,0,1,3.19,2.26,6.44,6.44,0,0,0,3.54,1.52,2.84,2.84,0,0,0,2.95-2.05,2,2,0,0,1,.16-.65,1,1,0,0,1,1.12-.29,5.73,5.73,0,0,1,1.07.62c1.32.78,3,.6,4.49.38,1.27-.18,2.86-.74,2.85-2,0-.84-.73-1.45-1.3-2.05s-1-1.58-.51-2.22a1.46,1.46,0,0,1,.73-.45c1.58-.51,3.51.17,4.84-.82a2.78,2.78,0,0,0,.7-3.34,4.24,4.24,0,0,0-2.84-2.16c-1.06-.27-2.41-.4-2.8-1.42s.35-1.85,1.13-2.4a8.33,8.33,0,0,0,2.28-1.73,2.72,2.72,0,0,0,.07-2.82,3.42,3.42,0,0,0-2.38-1.63,5,5,0,0,1-1.44-.32,1,1,0,0,1-.53-1.21c.14-.26.44-.4.61-.64a1.14,1.14,0,0,0-.42-1.5,5.91,5.91,0,0,0-1.61-.62c-1.15-.38-1.74-1-1.4-2.14s2-1.12,2.47-2.28-.76-3.19-1.67-3.82a21.83,21.83,0,0,0-3-1.36,3.21,3.21,0,0,1-2.06-2.42c-.08-1.13.77-2.09,1.46-3s1.29-2.16.68-3.13-1.88-1-2.92-1.31a4.73,4.73,0,0,1-2.88-2.59c-.27-.64-.41-1.34-.74-2-1-1.91-3.64-2.75-5.65-2.51a2.29,2.29,0,0,0-1.92,1.3,3.05,3.05,0,0,0-.7,1.32c-.15.93.33,2.1-.54,2.81-1.32,1.07-3.34-.37-3.27,2a11.76,11.76,0,0,0,.35,2.7,2.71,2.71,0,0,1,.09.41,2.59,2.59,0,0,1,.06.92,2.08,2.08,0,0,1-1.32,1.43,17.31,17.31,0,0,1-3,.32,3.93,3.93,0,0,0-2.57,1.49,3.11,3.11,0,0,0-.47,2.88c.36,1,1.26,1.87.92,2.83s-1.6,1.12-2.4,1.74a3.07,3.07,0,0,0-.91,3.07,6.77,6.77,0,0,1,.3,1.58c-.09,1.64-2.14,2.36-3,3.74a5.94,5.94,0,0,0-.37,4,4.31,4.31,0,0,0,.52,1.81c.33.52.85.87,1.21,1.36a2.67,2.67,0,0,1,.2,2.66,4.64,4.64,0,0,1-2.08,1.86,2.93,2.93,0,0,0-1.46,2.35c-.11,1.8.92,2.2,2.32,2.81,1.12.48,1,.62,1,1.95,0,2.7.9,3.46,3.56,3a6.54,6.54,0,0,1,2.56-.21c1,.31.67.56.7,1.41.07,2.17,2.6,1.56,3.67.63C378.66,258.06,380.21,256.82,381.88,256.66Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.88,256.66a3.54,3.54,0,0,1,2,.35,19.61,19.61,0,0,1,3.19,2.26,6.44,6.44,0,0,0,3.54,1.52,2.84,2.84,0,0,0,2.95-2.05,2,2,0,0,1,.16-.65,1,1,0,0,1,1.12-.29,5.73,5.73,0,0,1,1.07.62c1.32.78,3,.6,4.49.38,1.27-.18,2.86-.74,2.85-2,0-.84-.73-1.45-1.3-2.05s-1-1.58-.51-2.22a1.46,1.46,0,0,1,.73-.45c1.58-.51,3.51.17,4.84-.82a2.78,2.78,0,0,0,.7-3.34,4.24,4.24,0,0,0-2.84-2.16c-1.06-.27-2.41-.4-2.8-1.42s.35-1.85,1.13-2.4a8.33,8.33,0,0,0,2.28-1.73,2.72,2.72,0,0,0,.07-2.82,3.42,3.42,0,0,0-2.38-1.63,5,5,0,0,1-1.44-.32,1,1,0,0,1-.53-1.21c.14-.26.44-.4.61-.64a1.14,1.14,0,0,0-.42-1.5,5.91,5.91,0,0,0-1.61-.62c-1.15-.38-1.74-1-1.4-2.14s2-1.12,2.47-2.28-.76-3.19-1.67-3.82a21.83,21.83,0,0,0-3-1.36,3.21,3.21,0,0,1-2.06-2.42c-.08-1.13.77-2.09,1.46-3s1.29-2.16.68-3.13-1.88-1-2.92-1.31a4.73,4.73,0,0,1-2.88-2.59c-.27-.64-.41-1.34-.74-2-1-1.91-3.64-2.75-5.65-2.51a2.29,2.29,0,0,0-1.92,1.3,3.05,3.05,0,0,0-.7,1.32c-.15.93.33,2.1-.54,2.81-1.32,1.07-3.34-.37-3.27,2a11.76,11.76,0,0,0,.35,2.7,2.71,2.71,0,0,1,.09.41,2.59,2.59,0,0,1,.06.92,2.08,2.08,0,0,1-1.32,1.43,17.31,17.31,0,0,1-3,.32,3.93,3.93,0,0,0-2.57,1.49,3.11,3.11,0,0,0-.47,2.88c.36,1,1.26,1.87.92,2.83s-1.6,1.12-2.4,1.74a3.07,3.07,0,0,0-.91,3.07,6.77,6.77,0,0,1,.3,1.58c-.09,1.64-2.14,2.36-3,3.74a5.94,5.94,0,0,0-.37,4,4.31,4.31,0,0,0,.52,1.81c.33.52.85.87,1.21,1.36a2.67,2.67,0,0,1,.2,2.66,4.64,4.64,0,0,1-2.08,1.86,2.93,2.93,0,0,0-1.46,2.35c-.11,1.8.92,2.2,2.32,2.81,1.12.48,1,.62,1,1.95,0,2.7.9,3.46,3.56,3a6.54,6.54,0,0,1,2.56-.21c1,.31.67.56.7,1.41.07,2.17,2.6,1.56,3.67.63C378.66,258.06,380.21,256.82,381.88,256.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,256.06a3.5,3.5,0,0,0-.46-.65c-.21-.23-.44-.45-.65-.67a3.19,3.19,0,0,1-.67-1.1,1.59,1.59,0,0,1-.06-.3,1.1,1.1,0,0,1,.07-.57.73.73,0,0,1,.15-.25,1.46,1.46,0,0,1,.73-.45,3.5,3.5,0,0,1,.56-.13l.17,0,.43,0h.15c.47,0,.94,0,1.4,0h.26l.28,0,.3,0,.24,0h0a13.54,13.54,0,0,0-2.14-.33,6.09,6.09,0,0,0-4.63,1.83,4.12,4.12,0,0,1,.93,2.78c-3,.81-6-3.22-8.83-2,.17,1.45,0,3.41-1.41,3.73a2.31,2.31,0,0,1-2.19-1.05c-.51-.68-.83-1.5-1.35-2.18a4.62,4.62,0,0,0-6.12-.89c-.77.57-1.75,1.42-2.52.86s-.33-2.24-1.25-2.7c-.61-.31-1.47.18-2-.28a1.31,1.31,0,0,1-.35-.75c-.36-1.53-.68-3.31.29-4.56s2.68-1.79,2.48-3.19c-.16-1.19-1.68-1.55-2.87-1.68s-2.7-.71-2.64-1.91,1.65-1.74,1.89-2.9c.1-.49-.07-1,.15-1.49.34-.68,1.32-.71,1.88-1.21,1-.9.23-2.59.52-3.92.21-1,1-1.69,1.22-2.62a3.44,3.44,0,0,0-1.32-3.35,1,1,0,0,0-.5-.33A2.74,2.74,0,0,1,374,223a3.06,3.06,0,0,1-1.11-2.37,2.26,2.26,0,0,1,.2-.88,3.15,3.15,0,0,0,.45-1.52,3.86,3.86,0,0,0-2.37,1.44,3.11,3.11,0,0,0-.47,2.88c.36,1,1.26,1.87.92,2.83s-1.6,1.12-2.4,1.74a3.07,3.07,0,0,0-.91,3.07,6.77,6.77,0,0,1,.3,1.58c-.09,1.64-2.14,2.36-3,3.74a5.94,5.94,0,0,0-.37,4,4.31,4.31,0,0,0,.52,1.81c.33.52.85.87,1.21,1.36a2.67,2.67,0,0,1,.2,2.66,4.64,4.64,0,0,1-2.08,1.86,2.93,2.93,0,0,0-1.46,2.35c-.11,1.8.92,2.2,2.32,2.81,1.12.48,1,.62,1,1.95,0,2.7.9,3.46,3.56,3a6.54,6.54,0,0,1,2.56-.21c1,.31.67.56.7,1.41.07,2.17,2.6,1.56,3.67.63,1.24-1.08,2.79-2.32,4.46-2.48a3.54,3.54,0,0,1,2,.35,17.86,17.86,0,0,1,3,2.12c.35.27.72.54,1.1.78l.05,0c.12.08.25.15.38.22l.17.08.27.13.23.1.24.09.25.08.28.07.22,0a3,3,0,0,0,.52.05,3.25,3.25,0,0,0,1.87-.52,2.59,2.59,0,0,0,.7-.66,2.13,2.13,0,0,0,.38-.87,2,2,0,0,1,.16-.65.77.77,0,0,1,.49-.33,1.15,1.15,0,0,1,.32,0,1.7,1.7,0,0,1,.31.06,5.73,5.73,0,0,1,1.07.62,3.67,3.67,0,0,0,1.05.42A5.92,5.92,0,0,0,398,259a11.43,11.43,0,0,0,1.17,0c.39,0,.77-.09,1.15-.15a5.72,5.72,0,0,0,1-.21,3,3,0,0,0,1.61-1,1.36,1.36,0,0,0,.26-.82,1.46,1.46,0,0,0-.1-.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.74,234.48,385,248.84v-6.61l.74-28.15,1.07,28.15v4.45l8-13.92-8,17.08v43.63a.44.44,0,0,1-.27.37,1.44,1.44,0,0,1-1.28,0,.45.45,0,0,1-.26-.37v-41Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bush--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-2",
    d: "M380.82,296.88c2.07.33,3.93-.24,4.25-2.48a19.91,19.91,0,0,0,0-5.56c-.09-.67-.33-1.45-1-1.63a1.25,1.25,0,0,0-1.34.75,3.59,3.59,0,0,0-.22,1.63c-.33-.72-.82-1.56-1.62-1.58a1.48,1.48,0,0,0-1.32,1.49,4.28,4.28,0,0,0,.68,2.08,2.06,2.06,0,0,0-1.62.26,1.41,1.41,0,0,0-.06,1.83,4.18,4.18,0,0,0,1.63,1.17.73.73,0,0,0-1,.48,1.1,1.1,0,0,0,.43,1.11A2.27,2.27,0,0,0,380.82,296.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-2",
    d: "M384.42,297.77l4.95-2.86a3.91,3.91,0,0,0,1.08-1,2.8,2.8,0,0,0,.6-1.28.68.68,0,0,0-.05-.49c-.18-.26-.6-.17-.84,0a8.46,8.46,0,0,0-.67.67,7.64,7.64,0,0,0,.09-1.72.72.72,0,0,0-.21-.57.64.64,0,0,0-.69,0,3,3,0,0,0-1.15,1.83,6,6,0,0,0-.06-2.19c-.18-.78-1.07-1.09-1.38-.34a4.71,4.71,0,0,0-.26,1.25,5,5,0,0,0,.11,1.64,5.11,5.11,0,0,0-1.32-1.83.77.77,0,0,0-.76-.26c-.31.12-.37.53-.33.87a4.71,4.71,0,0,0,.67,2,4.22,4.22,0,0,0-1.67-.65.51.51,0,0,0-.53.17.71.71,0,0,0,.11.69,4.32,4.32,0,0,0,1.34,1.24,4.25,4.25,0,0,0-1.62-.17.53.53,0,0,0-.44.18c-.14.2,0,.48.2.66a5.23,5.23,0,0,0,1.16.69,1.57,1.57,0,0,0-.71.12.56.56,0,0,0-.34.58.7.7,0,0,0,.52.46A3.55,3.55,0,0,0,384.42,297.77Z",
    style: {
      fill: "#242424"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.4,251.72a3.54,3.54,0,0,0-2,.35,20.05,20.05,0,0,0-3.19,2.26,6.44,6.44,0,0,1-3.54,1.52,2.84,2.84,0,0,1-3-2,2,2,0,0,0-.16-.65,1,1,0,0,0-1.12-.29,5.73,5.73,0,0,0-1.07.62c-1.32.78-3,.6-4.49.38-1.27-.18-2.86-.74-2.85-2,0-.84.73-1.45,1.3-2s1-1.58.51-2.22a1.46,1.46,0,0,0-.73-.45c-1.58-.51-3.51.17-4.84-.82a2.78,2.78,0,0,1-.7-3.34,4.24,4.24,0,0,1,2.84-2.16c1.06-.27,2.41-.4,2.8-1.42s-.34-1.85-1.13-2.4a8.33,8.33,0,0,1-2.28-1.73,2.72,2.72,0,0,1-.07-2.82,3.42,3.42,0,0,1,2.38-1.63,5,5,0,0,0,1.44-.32,1,1,0,0,0,.53-1.21c-.14-.26-.44-.4-.61-.64a1.14,1.14,0,0,1,.42-1.5,6,6,0,0,1,1.61-.62c1.15-.38,1.74-1,1.4-2.14s-2-1.12-2.47-2.28.76-3.2,1.67-3.82a21.83,21.83,0,0,1,3-1.36,3.21,3.21,0,0,0,2.06-2.42c.09-1.13-.77-2.09-1.46-3s-1.29-2.16-.68-3.13,1.88-1,2.92-1.31a4.73,4.73,0,0,0,2.88-2.59c.27-.64.41-1.34.74-2,1-1.91,3.64-2.75,5.65-2.51a2.29,2.29,0,0,1,1.92,1.3,3.05,3.05,0,0,1,.7,1.32c.15.93-.33,2.1.54,2.81,1.32,1.07,3.34-.38,3.27,2a11.76,11.76,0,0,1-.35,2.7,2.71,2.71,0,0,0-.09.41,2.59,2.59,0,0,0-.06.92,2.08,2.08,0,0,0,1.32,1.43,17.31,17.31,0,0,0,3,.32,3.93,3.93,0,0,1,2.57,1.49,3.08,3.08,0,0,1,.47,2.88c-.36,1-1.26,1.87-.92,2.83s1.6,1.12,2.4,1.74a3.07,3.07,0,0,1,.91,3.07,6.77,6.77,0,0,0-.3,1.58c.09,1.64,2.14,2.36,3,3.74a5.94,5.94,0,0,1,.37,4,4.31,4.31,0,0,1-.52,1.81c-.33.52-.85.87-1.21,1.36a2.67,2.67,0,0,0-.2,2.66,4.64,4.64,0,0,0,2.08,1.86,2.93,2.93,0,0,1,1.46,2.35c.11,1.8-.92,2.2-2.32,2.81-1.12.48-1,.62-1,1.95,0,2.7-.9,3.46-3.55,3a6.6,6.6,0,0,0-2.57-.21c-1,.31-.67.56-.7,1.41-.07,2.17-2.6,1.56-3.67.63C159.62,253.12,158.07,251.88,156.4,251.72Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,251.72a3.54,3.54,0,0,0-2,.35,20.05,20.05,0,0,0-3.19,2.26,6.44,6.44,0,0,1-3.54,1.52,2.84,2.84,0,0,1-3-2,2,2,0,0,0-.16-.65,1,1,0,0,0-1.12-.29,5.73,5.73,0,0,0-1.07.62c-1.32.78-3,.6-4.49.38-1.27-.18-2.86-.74-2.85-2,0-.84.73-1.45,1.3-2s1-1.58.51-2.22a1.46,1.46,0,0,0-.73-.45c-1.58-.51-3.51.17-4.84-.82a2.78,2.78,0,0,1-.7-3.34,4.24,4.24,0,0,1,2.84-2.16c1.06-.27,2.41-.4,2.8-1.42s-.34-1.85-1.13-2.4a8.33,8.33,0,0,1-2.28-1.73,2.72,2.72,0,0,1-.07-2.82,3.42,3.42,0,0,1,2.38-1.63,5,5,0,0,0,1.44-.32,1,1,0,0,0,.53-1.21c-.14-.26-.44-.4-.61-.64a1.14,1.14,0,0,1,.42-1.5,6,6,0,0,1,1.61-.62c1.15-.38,1.74-1,1.4-2.14s-2-1.12-2.47-2.28.76-3.2,1.67-3.82a21.83,21.83,0,0,1,3-1.36,3.21,3.21,0,0,0,2.06-2.42c.09-1.13-.77-2.09-1.46-3s-1.29-2.16-.68-3.13,1.88-1,2.92-1.31a4.73,4.73,0,0,0,2.88-2.59c.27-.64.41-1.34.74-2,1-1.91,3.64-2.75,5.65-2.51a2.29,2.29,0,0,1,1.92,1.3,3.05,3.05,0,0,1,.7,1.32c.15.93-.33,2.1.54,2.81,1.32,1.07,3.34-.38,3.27,2a11.76,11.76,0,0,1-.35,2.7,2.71,2.71,0,0,0-.09.41,2.59,2.59,0,0,0-.06.92,2.08,2.08,0,0,0,1.32,1.43,17.31,17.31,0,0,0,3,.32,3.93,3.93,0,0,1,2.57,1.49,3.08,3.08,0,0,1,.47,2.88c-.36,1-1.26,1.87-.92,2.83s1.6,1.12,2.4,1.74a3.07,3.07,0,0,1,.91,3.07,6.77,6.77,0,0,0-.3,1.58c.09,1.64,2.14,2.36,3,3.74a5.94,5.94,0,0,1,.37,4,4.31,4.31,0,0,1-.52,1.81c-.33.52-.85.87-1.21,1.36a2.67,2.67,0,0,0-.2,2.66,4.64,4.64,0,0,0,2.08,1.86,2.93,2.93,0,0,1,1.46,2.35c.11,1.8-.92,2.2-2.32,2.81-1.12.48-1,.62-1,1.95,0,2.7-.9,3.46-3.55,3a6.6,6.6,0,0,0-2.57-.21c-1,.31-.67.56-.7,1.41-.07,2.17-2.6,1.56-3.67.63C159.62,253.12,158.07,251.88,156.4,251.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,251.12a3.5,3.5,0,0,1,.46-.65c.21-.23.44-.45.65-.67a3.19,3.19,0,0,0,.67-1.1,1.59,1.59,0,0,0,.06-.3,1.1,1.1,0,0,0-.07-.57.73.73,0,0,0-.15-.25,1.46,1.46,0,0,0-.73-.45,3.65,3.65,0,0,0-.55-.13l-.17,0-.44,0h-.15c-.47,0-.94,0-1.4,0h-.26l-.28,0-.3,0-.24,0h0a13.54,13.54,0,0,1,2.14-.33,6.09,6.09,0,0,1,4.63,1.83,4.18,4.18,0,0,0-.93,2.78c3,.81,6-3.22,8.83-2-.17,1.45,0,3.41,1.41,3.73a2.3,2.3,0,0,0,2.19-1.05c.52-.68.83-1.5,1.35-2.18a4.62,4.62,0,0,1,6.12-.89c.77.57,1.75,1.42,2.52.86s.33-2.24,1.25-2.7c.61-.31,1.47.18,2-.28a1.31,1.31,0,0,0,.35-.75c.36-1.53.68-3.31-.29-4.56s-2.68-1.79-2.48-3.19c.16-1.19,1.68-1.55,2.87-1.68s2.7-.71,2.64-1.91-1.65-1.74-1.88-2.9c-.11-.49.06-1-.16-1.49-.34-.68-1.32-.71-1.88-1.21-1-.9-.23-2.59-.52-3.92-.21-1-1-1.69-1.22-2.62a3.44,3.44,0,0,1,1.32-3.35,1,1,0,0,1,.5-.33,2.74,2.74,0,0,0,1.19-.57,3.06,3.06,0,0,0,1.11-2.37,2.26,2.26,0,0,0-.2-.88,3.15,3.15,0,0,1-.45-1.52,3.86,3.86,0,0,1,2.37,1.44,3.08,3.08,0,0,1,.47,2.88c-.36,1-1.26,1.87-.92,2.83s1.6,1.12,2.4,1.74a3.07,3.07,0,0,1,.91,3.07,6.77,6.77,0,0,0-.3,1.58c.09,1.64,2.14,2.36,3,3.74a5.88,5.88,0,0,1,.37,4,4.31,4.31,0,0,1-.52,1.81c-.33.52-.85.87-1.21,1.36a2.67,2.67,0,0,0-.2,2.66,4.64,4.64,0,0,0,2.08,1.86,2.93,2.93,0,0,1,1.46,2.35c.11,1.8-.92,2.2-2.32,2.81-1.12.48-1,.62-1,1.95,0,2.7-.9,3.46-3.55,3a6.6,6.6,0,0,0-2.57-.21c-1,.31-.67.56-.7,1.41-.07,2.17-2.6,1.56-3.67.63-1.24-1.08-2.79-2.32-4.46-2.48a3.54,3.54,0,0,0-2,.35,17.86,17.86,0,0,0-3,2.12c-.35.27-.72.54-1.1.78l0,0c-.12.08-.25.15-.38.22l-.16.08-.28.13-.23.1-.24.09-.25.08-.28.07-.22,0a3,3,0,0,1-.52,0,3.25,3.25,0,0,1-1.87-.52,2.59,2.59,0,0,1-.7-.66,2.13,2.13,0,0,1-.38-.87,2,2,0,0,0-.16-.65.77.77,0,0,0-.49-.33,1.15,1.15,0,0,0-.32,0,1.7,1.7,0,0,0-.31.06,5.73,5.73,0,0,0-1.07.62,3.67,3.67,0,0,1-1,.42,5.92,5.92,0,0,1-1.12.15,11.43,11.43,0,0,1-1.17,0c-.39,0-.77-.09-1.15-.15a5.72,5.72,0,0,1-1-.21,3,3,0,0,1-1.61-1,1.36,1.36,0,0,1-.26-.82,1.46,1.46,0,0,1,.1-.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.54,229.54l-7.25,14.36v-6.61l-.73-28.15-1.08,28.15v4.45l-8-13.92,8,17.08V299a.45.45,0,0,0,.27.37,1.44,1.44,0,0,0,1.28,0,.46.46,0,0,0,.26-.37V247.56Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-2",
    d: "M149.74,302.43c2.08.33,3.93-.24,4.25-2.48a19.91,19.91,0,0,0,0-5.56c-.09-.67-.33-1.46-1-1.63a1.24,1.24,0,0,0-1.33.75,3.6,3.6,0,0,0-.23,1.63c-.33-.72-.82-1.56-1.61-1.58a1.47,1.47,0,0,0-1.32,1.49,4.26,4.26,0,0,0,.67,2.08,2,2,0,0,0-1.61.25,1.41,1.41,0,0,0-.06,1.84,4.15,4.15,0,0,0,1.62,1.17.72.72,0,0,0-1,.48,1.09,1.09,0,0,0,.42,1.11A2.44,2.44,0,0,0,149.74,302.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-2",
    d: "M153.34,303.31l4.95-2.86a4,4,0,0,0,1.08-1,2.8,2.8,0,0,0,.6-1.28.64.64,0,0,0-.05-.49c-.18-.26-.6-.17-.84,0s-.42.4-.67.67a7.65,7.65,0,0,0,.1-1.72.8.8,0,0,0-.21-.57.62.62,0,0,0-.69,0,2.9,2.9,0,0,0-1.15,1.83,6,6,0,0,0-.07-2.19c-.17-.78-1.07-1.09-1.37-.34a4,4,0,0,0-.26,1.24,5.07,5.07,0,0,0,.11,1.65,5.24,5.24,0,0,0-1.32-1.83.82.82,0,0,0-.77-.27c-.31.12-.36.54-.33.88a4.71,4.71,0,0,0,.67,2,4,4,0,0,0-1.67-.65.51.51,0,0,0-.53.17.69.69,0,0,0,.12.69,4,4,0,0,0,1.33,1.23,4.67,4.67,0,0,0-1.62-.17.6.6,0,0,0-.44.19c-.14.2,0,.48.21.65a4.51,4.51,0,0,0,1.16.69,1.91,1.91,0,0,0-.72.12.57.57,0,0,0-.34.59.71.71,0,0,0,.53.46A3.43,3.43,0,0,0,153.34,303.31Z",
    style: {
      fill: "#242424"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--house--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "296.75 350.9 206.9 299.04 206.9 172.24 286.76 218.33 286.76 275.97 296.75 281.74 296.75 350.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.75 350.9 206.9 299.04 206.9 172.24 286.76 218.33 286.76 275.97 296.75 281.74 296.75 350.9",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.75 350.9 369.95 308.63 369.95 251 296.75 293.26 296.75 350.9",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.76 216.77 286.76 275.97 349.66 239.62 350.01 180.26 286.76 216.77",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.98 307.43 305.61 337.67 305.61 297.8 357.98 267.56 357.98 307.43",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.98 307.43 305.61 337.67 305.61 297.8 357.98 267.56 357.98 307.43",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "311.66 334.17 324.72 326.63 357.98 273.72 357.98 267.56 350.99 271.6 311.66 334.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.98 282.3 357.98 277.71 328.66 324.36 333.18 321.75 357.98 282.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.57,339.65V295.86l.35-.2,54.75-31.61v43.79l-.35.2Zm1.4-43v40.56L357.28,307V266.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.12,
    y: 288.45,
    width: 62.01,
    height: 1.39,
    transform: "translate(-100.22 204.32) rotate(-30)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.38,
    y: 275.6,
    width: 1.4,
    height: 42.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.48,
    y: 285.93,
    width: 1.4,
    height: 42.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.31 239.02 296.94 269.26 296.94 229.39 349.31 199.15 349.31 239.02",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "349.31 239.02 296.94 269.26 296.94 229.39 349.31 199.15 349.31 239.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "303 265.76 316.06 258.22 349.31 205.31 349.31 199.15 342.33 203.18 303 265.76",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.31 213.88 349.31 209.3 320 255.95 324.52 253.34 349.31 213.88",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.91,271.23V227.45l.35-.2L350,195.64v43.78l-.35.2Zm1.4-43v40.56l52.31-30.2V198.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.46,
    y: 220.04,
    width: 62.01,
    height: 1.39,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -67.17, 190.86)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.71,
    y: 207.18,
    width: 1.4,
    height: 42.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.81,
    y: 217.52,
    width: 1.4,
    height: 42.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.76 222.18 286.76 263.44 350.07 201 350.07 185.68 286.76 222.18",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.75 326.93 369.95 258.68 369.95 251 296.75 293.26 296.75 326.93",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.28 252.92 373.28 168.38 293.42 214.49 293.42 226.01 363.3 185.67 363.3 247.16 293.42 287.5 293.42 299.03 373.28 252.92",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.28 252.92 373.28 168.38 293.42 214.49 293.42 226.01 363.3 185.67 363.3 247.16 293.42 287.5 293.42 299.03 373.28 252.92",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.28 168.38 280.11 114.59 200.25 160.7 293.42 214.49 373.28 168.38",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.28 168.38 280.11 114.59 200.25 160.7 293.42 214.49 373.28 168.38",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 118.44 280.11 126.12 359.97 172.23 366.61 168.38 280.11 118.44",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 118.44 280.11 126.12 359.97 172.23 366.61 168.38 280.11 118.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 118.44 206.9 160.7 213.56 164.54 280.11 126.12 280.11 118.44",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.11 118.44 206.9 160.7 213.56 164.54 280.11 126.12 280.11 118.44",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.56 164.54 293.42 210.65 359.97 172.23 280.11 126.12 213.56 164.54",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.3 247.16 349.99 239.47 349.99 193.35 363.3 185.67 363.3 247.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.99 239.47 286.76 275.97 276.78 270.21 270.13 274.05 293.42 287.5 363.3 247.16 349.99 239.47",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.42 287.5 293.42 299.03 270.13 285.58 270.13 274.05 293.42 287.5",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.42 287.5 293.42 299.03 270.13 285.58 270.13 274.05 293.42 287.5",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.42 226.01 200.25 172.23 200.25 160.7 293.42 214.49 293.42 226.01",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.42 226.01 200.25 172.23 200.25 160.7 293.42 214.49 293.42 226.01",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.42,284.3a.41.41,0,0,1-.41-.41V264.21l.2-.12,66.56-38.42a.4.4,0,0,1,.56.15.42.42,0,0,1-.15.56l-66.35,38.3v19.21A.41.41,0,0,1,293.42,284.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,276.38a.41.41,0,0,1-.41-.41V256.76a.41.41,0,0,1,.82,0V276A.41.41,0,0,1,306.73,276.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,268.7a.41.41,0,0,1-.41-.41V249.08a.41.41,0,1,1,.82,0v19.21A.41.41,0,0,1,320,268.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.35,261a.41.41,0,0,1-.41-.41V241.38a.41.41,0,0,1,.82,0v19.21A.41.41,0,0,1,333.35,261Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,253.33a.41.41,0,0,1-.41-.41V233.71a.41.41,0,0,1,.82,0v19.21A.41.41,0,0,1,346.66,253.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,245.64a.41.41,0,0,1-.41-.41V226a.41.41,0,0,1,.82,0v19.21A.41.41,0,0,1,360,245.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.42,284.3a.41.41,0,0,1-.41-.41V264.68l-66.35-38.3a.41.41,0,0,1-.14-.56.39.39,0,0,1,.55-.15l66.76,38.54v19.68A.41.41,0,0,1,293.42,284.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.11,276.38a.41.41,0,0,1-.41-.41V256.76a.41.41,0,0,1,.82,0V276A.41.41,0,0,1,280.11,276.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8,268.7h0a.41.41,0,0,1-.41-.41V249.08a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.41.41v19.21A.41.41,0,0,1,266.8,268.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.49,261h0a.41.41,0,0,1-.41-.41V241.38a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.41.41v19.21A.41.41,0,0,1,253.49,261Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,253.33h0a.41.41,0,0,1-.41-.41V233.71a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.41.41v19.21A.41.41,0,0,1,240.18,253.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.87,245.64h0a.41.41,0,0,1-.41-.41V226a.41.41,0,0,1,.41-.41h0a.41.41,0,0,1,.41.41v19.21A.41.41,0,0,1,226.87,245.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.51 358.61 276.78 339.37 276.78 289.42 270.13 285.58 270.13 274.05 276.78 270.21 276.78 231.78 243.51 250.99 243.51 358.61",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.78 231.78 206.9 191.43 173.63 210.64 243.51 250.99 276.78 231.78",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.63 210.64 173.63 318.24 243.51 358.61 243.51 250.99 173.63 210.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.63 210.64 173.63 318.24 243.51 358.61 243.51 250.99 173.63 210.64",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.38 310.03 258.38 342.74 262.82 340.17 262.82 307.46 258.38 310.03",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.38 310.03 258.38 342.74 262.82 340.17 262.82 307.46 258.38 310.03",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.38 326.8 258.38 336.19 262.82 329.11 262.82 319.73 258.38 326.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.38 339.01 258.38 342.26 262.82 335.19 262.82 331.94 258.38 339.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,344.82V308.87l7.95-4.59v36Zm1.39-35.14v32.73l5.17-3V306.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,351.57V307.13l16.63-9.6V342Zm1.39-43.63v41.22l13.85-8V299.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.78 285.29 243.51 334.85 243.51 297.11 276.78 277.89 276.78 285.29",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.35 342.74 254.5 353.05 254.5 356.06 272.35 345.75 272.35 342.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 351.12 254.5 353.05 272.35 342.74 269.07 340.81 251.22 351.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.52 363.76 272.35 345.77 254.5 356.08 285.66 374.07 303.52 363.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.22 354.13 254.5 356.06 254.5 353.05 251.22 351.12 251.22 354.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.76 243.48 279 225.44 279 288.46 247.76 306.5 247.76 243.48",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.4 252.37 254.4 292.24 272.35 281.88 272.35 242.01 254.4 252.37",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.4 252.37 254.4 292.24 272.35 281.88 272.35 242.01 254.4 252.37",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.4 281.58 254.4 292.24 256.95 290.76 272.35 266.27 272.35 253.03 254.4 281.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.35 270.26 260.89 288.49 265.41 285.88 272.35 274.85 272.35 270.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.71,293.44V249.66l19.34-11.16v43.78Zm1.39-43V291l16.55-9.56V240.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.02,
    y: 252.58,
    width: 20.72,
    height: 1.39,
    transform: "translate(-91.34 165.57) rotate(-29.99)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.76 306.5 165.94 259.36 165.78 196.25 247.76 243.48 247.76 306.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279 225.44 247.76 243.48 165.78 196.25 199.13 177.04 279 225.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.13 177.04 214.24 186.19 199.05 177.69 165.78 196.25 199.13 177.04",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-2",
    points: "150.18 314.05 209.79 348.46 211.21 347.63 151.6 313.22 150.18 314.05",
    style: {
      fill: "#242424",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--fence--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.65 346.31 206.65 324.44 205.03 321.1 203.38 322.56 203.38 344.43 206.65 346.31",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.65 346.31 206.65 324.44 205.03 321.1 203.38 322.56 203.38 344.43 206.65 346.31",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.65 324.44 207.47 323.97 207.47 345.84 206.65 346.31 206.65 324.44",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.65 324.44 207.47 323.97 207.47 345.84 206.65 346.31 206.65 324.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.03 321.1 205.85 320.61 207.47 323.97 206.65 324.44 205.03 321.1",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.54 339.35 194.54 317.48 192.92 314.14 191.27 315.6 191.27 337.47 194.54 339.35",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.54 339.35 194.54 317.48 192.92 314.14 191.27 315.6 191.27 337.47 194.54 339.35",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.54 317.48 195.36 317.01 195.36 338.88 194.54 339.35 194.54 317.48",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.54 317.48 195.36 317.01 195.36 338.88 194.54 339.35 194.54 317.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.92 314.14 193.74 313.65 195.36 317.01 194.54 317.48 192.92 314.14",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.44 332.39 182.44 310.52 180.81 307.18 179.16 308.63 179.16 330.51 182.44 332.39",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.44 332.39 182.44 310.52 180.81 307.18 179.16 308.63 179.16 330.51 182.44 332.39",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.44 310.52 183.25 310.05 183.25 331.92 182.44 332.39 182.44 310.52",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.44 310.52 183.25 310.05 183.25 331.92 182.44 332.39 182.44 310.52",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.81 307.18 181.63 306.69 183.25 310.05 182.44 310.52 180.81 307.18",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.33 325.43 170.33 303.56 168.71 300.22 167.05 301.68 167.05 323.55 170.33 325.43",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.33 325.43 170.33 303.56 168.71 300.22 167.05 301.68 167.05 323.55 170.33 325.43",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.33 303.56 171.15 303.09 171.15 324.96 170.33 325.43 170.33 303.56",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.33 303.56 171.15 303.09 171.15 324.96 170.33 325.43 170.33 303.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.71 300.22 169.52 299.73 171.15 303.09 170.33 303.56 168.71 300.22",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.22 318.47 158.22 296.6 156.6 293.26 154.94 294.72 154.94 316.59 158.22 318.47",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.22 318.47 158.22 296.6 156.6 293.26 154.94 294.72 154.94 316.59 158.22 318.47",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.22 296.6 159.04 296.13 159.04 318 158.22 318.47 158.22 296.6",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.22 296.6 159.04 296.13 159.04 318 158.22 318.47 158.22 296.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.6 293.26 157.41 292.77 159.04 296.13 158.22 296.6 156.6 293.26",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 341.46 151.47 307.63 151.47 308.91 210.36 342.75 210.36 341.46",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 341.46 151.47 307.63 151.47 308.91 210.36 342.75 210.36 341.46",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 341.46 211.21 340.98 211.21 342.27 210.36 342.75 210.36 341.46",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 341.46 211.21 340.98 211.21 342.27 210.36 342.75 210.36 341.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.47 307.63 210.36 341.46 211.21 340.98 152.31 307.14 151.47 307.63",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 333.22 151.47 299.38 151.47 300.67 210.36 334.5 210.36 333.22",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 333.22 151.47 299.38 151.47 300.67 210.36 334.5 210.36 333.22",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 333.22 211.21 332.73 211.21 334.02 210.36 334.5 210.36 333.22",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.36 333.22 211.21 332.73 211.21 334.02 210.36 334.5 210.36 333.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.47 299.38 210.36 333.22 211.21 332.73 152.31 298.89 151.47 299.38",
    style: {
      fill: "#242424"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screwdriver--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screwdriver--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.45,377.58l7.7,13.32,26-15c1.06-.53,1.73-1.77,1.73-3.59a12,12,0,0,0-5.44-9.43,3.84,3.84,0,0,0-3.86-.38h0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.91,380.34h0c-.11,2-3,2.47-3,2.47l5.44,9.43s1.82-2.23,3.63-1.35h0c2.68,1.16,4.76-.28,4.76-3.48a12,12,0,0,0-5.44-9.43C426.53,376.35,424.24,377.43,423.91,380.34Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.91,380.34h0c-.11,2-3,2.47-3,2.47l5.44,9.43s1.82-2.23,3.63-1.35h0c2.68,1.16,4.76-.28,4.76-3.48a12,12,0,0,0-5.44-9.43C426.53,376.35,424.24,377.43,423.91,380.34Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.22,382.4a6,6,0,0,1-1.3.4l5.44,9.43a5.8,5.8,0,0,1,1-.91A12.19,12.19,0,0,0,422.22,382.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,383.47l.45.79a5.73,5.73,0,0,0-.23,1.68,12,12,0,0,0,5.45,9.44,6.17,6.17,0,0,0,1.58.64l.45.79,1.82-1.05h0a3.84,3.84,0,0,0,1.59-3.53,12.06,12.06,0,0,0-5.44-9.43,3.84,3.84,0,0,0-3.86-.38h0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.55,393.28a12,12,0,0,0-5.45-9.43c-3-1.74-5.45-.33-5.45,3.14a12,12,0,0,0,5.45,9.44C422.11,398.16,424.55,396.75,424.55,393.28Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.55,393.28a12,12,0,0,0-5.45-9.43c-3-1.74-5.45-.33-5.45,3.14a12,12,0,0,0,5.45,9.44C422.11,398.16,424.55,396.75,424.55,393.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,394.7a9.52,9.52,0,0,0,1.35,1.21l1.28-3.63-1.54-1.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.42,368.58h0a1.51,1.51,0,0,1-.55,2.06l-18.54,10.7a1.51,1.51,0,0,1-2.06-.55h0a1.51,1.51,0,0,1,.55-2.05L454.37,368A1.5,1.5,0,0,1,456.42,368.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.08,364.6h0a.88.88,0,0,1-.07,1.54l-18.9,10.91a2.07,2.07,0,0,1-2.18-.24h0a.88.88,0,0,1,.06-1.54l18.9-10.91A2,2,0,0,1,453.08,364.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,373.48h0a.87.87,0,0,0-1.36-.71l-18.9,10.9a2,2,0,0,0-.88,2h0a.87.87,0,0,0,1.36.71l18.9-10.91A2,2,0,0,0,458.2,373.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.34,415.28v3.63l9.08-3s1.82-3.34,3.63-4.39l34.49-19.91,1.07-3-1.07-.61-34.49,19.91a3.62,3.62,0,0,1-3.63-.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.41,415.89v3.64l9.07-3s1.82-3.33,3.63-4.38l34.5-19.91v-3.64l-34.5,19.92a3.62,3.62,0,0,1-3.63-.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.41 419.53 371.34 418.91 371.34 415.28 372.41 415.89 372.41 419.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.34 415.28 372.41 415.89 381.48 408.37 380.42 407.75 371.34 415.28",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hammer--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hammer--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.68,387.07a11.54,11.54,0,0,1,5.17,9.08,3.63,3.63,0,0,1-1.59,3.38l-35,19.9L435,406.6l34.93-19.89A3.63,3.63,0,0,1,473.68,387.07Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.55,405a13.25,13.25,0,0,1,5.94,10.44c0,1.94-.71,3.29-1.82,3.9l-2.2,1.25-8.4-14.76,2.18-1.24C437.35,404,438.87,404,440.55,405Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.55,405a13.25,13.25,0,0,1,5.94,10.44c0,1.94-.71,3.29-1.82,3.9l-2.2,1.25-8.4-14.76,2.18-1.24C437.35,404,438.87,404,440.55,405Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.24,416.74c0,3.84-2.72,5.37-6,3.44a13.32,13.32,0,0,1-5.94-10.45c0-3.83,2.72-5.37,6-3.43A13.25,13.25,0,0,1,444.24,416.74Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.26,410.21a5.84,5.84,0,0,1,2.6,4.57,1.82,1.82,0,0,1-.8,1.7L380.9,450.16l-3.67-6.45L436.38,410A1.82,1.82,0,0,1,438.26,410.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.7,448.06l1.2,2.1,59.16-33.68a1.82,1.82,0,0,0,.8-1.7,4.68,4.68,0,0,0-.24-1.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,447.48a8.07,8.07,0,0,0,.89,4,15.18,15.18,0,0,0,6.42,6.93c.48.3,1.28.77,1.78,1.06l6.6,3.86a4.49,4.49,0,0,0,1.93.53h1.29a4.54,4.54,0,0,1,1.94.53l3.6,1.69a1.45,1.45,0,0,0,1.65-.19l3.21-3.19a.84.84,0,0,0,.28-.57c0-.26,0-9.43,0-9.58a.74.74,0,0,0-.4-.81l-1.57-.92a2,2,0,0,1-.88-1.56v-1.82a2,2,0,0,0-.89-1.56L373.08,441a2.31,2.31,0,0,0-1.84-.1c-1.56.67-4.72,1.86-6.89,1.53-2.92-.45-6.88-3.27-7.28-8.86a7.16,7.16,0,0,0-1.56,4.39C355.49,439.07,355.57,444.91,355.46,447.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.69,451.72l-1.57-.92a2,2,0,0,1-.88-1.56v-1.82a2,2,0,0,0-.89-1.56L373.08,441a2.31,2.31,0,0,0-1.84-.1c-1.56.67-4.72,1.86-6.89,1.53-2.92-.45-6.88-3.27-7.28-8.86a7.39,7.39,0,0,0-.66,8.14,15.27,15.27,0,0,0,6.41,6.93c.49.3,1.29.77,1.79,1l6.6,3.87a4.49,4.49,0,0,0,1.93.53h1.29a4.46,4.46,0,0,1,1.93.53l3.61,1.69a1.46,1.46,0,0,0,1.65-.19l3.21-3.19A.73.73,0,0,0,384.69,451.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.67,452a14,14,0,0,0-6.43,11c0,2.06.71,3.49,1.88,4.15l6.3,3.69,9.08-15.53-6.27-3.67C386.08,450.89,384.47,451,382.67,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.58,466.68c0,4.06,2.82,5.72,6.35,3.71a14.06,14.06,0,0,0,6.43-11c0-4.06-2.81-5.72-6.34-3.71A14.09,14.09,0,0,0,382.58,466.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,453.31a3.65,3.65,0,0,1,1.65,2.9,1.15,1.15,0,0,1-.51,1.08l-1.66.95-2.33-4.1,1.65-.95A1.16,1.16,0,0,1,365.36,453.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.33,457.16c0,1.07-.75,1.49-1.67.95a3.65,3.65,0,0,1-1.65-2.9c0-1.06.75-1.49,1.67-.95A3.68,3.68,0,0,1,365.33,457.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,442.44a17.65,17.65,0,0,0,3.64,7.16,9.69,9.69,0,0,1-3.65-4.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.89,392.39h0a1.39,1.39,0,0,1-.52,1.88l-26.39,15a1.38,1.38,0,0,1-1.88-.52h0a1.39,1.39,0,0,1,.52-1.88l26.39-15A1.39,1.39,0,0,1,474.89,392.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.84,388.71h0a.81.81,0,0,1-.07,1.41l-26.71,15.21a1.88,1.88,0,0,1-2-.24h0a.8.8,0,0,1,.07-1.41l26.7-15.2A1.9,1.9,0,0,1,471.84,388.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.49,396.89h0a.8.8,0,0,0-1.25-.66l-26.71,15.2a1.89,1.89,0,0,0-.82,1.84h0a.81.81,0,0,0,1.25.66l26.71-15.2A1.89,1.89,0,0,0,476.49,396.89Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trowel--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--trowel--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.21,356.53a2.45,2.45,0,0,1-1.06,2.27l-19,10.79a4.94,4.94,0,1,1-4.88-8.59l18.94-10.78a2.42,2.42,0,0,1,2.5.24A7.7,7.7,0,0,1,387.21,356.53Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.21,356.53a7.84,7.84,0,0,0-2.2-5.06c1.41,2,1.61,4-2.64,6.43s-13.69,7.87-15.52,8.9-5.32,2.15-7.14-1.1a4.77,4.77,0,0,0,.6,2.12,5,5,0,0,0,6.88,1.77l19-10.79A2.45,2.45,0,0,0,387.21,356.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.34,365.29a3.73,3.73,0,0,1,1.67,2.94,1.17,1.17,0,0,1-.51,1.09l-1.43.8L358.71,366l1.42-.79A1.16,1.16,0,0,1,361.34,365.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.57,369c0,1.07-.76,1.51-1.69,1a3.76,3.76,0,0,1-1.68-2.94c0-1.07.77-1.51,1.7-1A3.72,3.72,0,0,1,361.57,369Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,368.68a2.39,2.39,0,0,0-1.07-1.88.73.73,0,0,0-.81-.05l-3.48,2a10.3,10.3,0,0,0-5.14,8.89v3a9.46,9.46,0,0,1-4.72,8.17l-2.81,1.63,1.53,2.65,2.81-1.62a12.54,12.54,0,0,0,6.25-10.83v-3a7.24,7.24,0,0,1,3.61-6.24l3.51-2h0A.74.74,0,0,0,361,368.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,397.43l-27.89-16.1a3.31,3.31,0,0,0-4.36,1l-17.35,26a2.22,2.22,0,0,0-.45,1.18c0,.16,0,.77,0,.92,0,.66.62,1,1.73.72l48-10.65c.89-.19,1.34-.57,1.34-1,0-.16,0-.79,0-.95C362.8,398.24,362.47,397.82,361.8,397.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.91,381.33l27.89,16.1c1.46.85,1.31,1.83-.34,2.2l-48,10.65c-1.65.37-2.23-.48-1.29-1.89l17.35-26A3.31,3.31,0,0,1,333.91,381.33Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--color-palette--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Palette--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.27,446.42h0a.19.19,0,0,1,0-.07l3.45-7.44a.62.62,0,0,1,.62-.21l62.17,9.62c.23,0,.38.16.37.29h0v1.3h0a.22.22,0,0,1,0,.08l-3.45,7.43c-.07.16-.35.25-.63.21L268.65,448c-.23,0-.38-.16-.38-.29h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.53,448.32l-62.17-9.62a.62.62,0,0,0-.62.21l-3.45,7.44c-.07.15.09.32.36.36l62.16,9.61a.61.61,0,0,0,.63-.2l3.45-7.44C335,448.53,334.8,448.36,334.53,448.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.12 449.7 329.05 454.15 321.35 452.95 323.41 448.51 331.12 449.7",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.12 449.7 329.05 454.15 321.35 452.95 323.41 448.51 331.12 449.7",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.4 446.65 309.34 451.1 301.63 449.9 303.7 445.46 311.4 446.65",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.4 446.65 309.34 451.1 301.63 449.9 303.7 445.46 311.4 446.65",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.54 445.13 299.48 449.57 291.78 448.38 293.84 443.93 301.54 445.13",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.54 445.13 299.48 449.57 291.78 448.38 293.84 443.93 301.54 445.13",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.69 443.6 289.62 448.05 281.92 446.85 283.98 442.41 291.69 443.6",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.69 443.6 289.62 448.05 281.92 446.85 283.98 442.41 291.69 443.6",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.83 442.07 279.76 446.52 272.06 445.33 274.13 440.88 281.83 442.07",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.26 448.18 319.19 452.62 311.49 451.43 313.56 446.98 321.26 448.18",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.26 448.18 319.19 452.62 311.49 451.43 313.56 446.98 321.26 448.18",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,456.26v1.3a.28.28,0,0,0,.16-.14l3.45-7.44s0,0,0-.06v-1.31a.14.14,0,0,1,0,.07l-3.45,7.44A.38.38,0,0,1,331.28,456.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.64,434.47h0a.21.21,0,0,1,.07-.15l6.66-6.66a.76.76,0,0,1,.7-.11l55.73,18.58c.17.05.26.15.26.25h0v1.3h0a.21.21,0,0,1-.07.15l-6.66,6.67a.73.73,0,0,1-.7.1L271.89,436c-.16,0-.25-.15-.25-.25h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.8,446.13l-55.73-18.58a.76.76,0,0,0-.7.11l-6.66,6.66c-.14.14-.06.32.18.41l55.74,18.57a.73.73,0,0,0,.7-.1l6.66-6.67C335.13,446.39,335.05,446.21,334.8,446.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.89 446.95 326.9 450.94 320 448.63 323.99 444.65 330.89 446.95",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.21 441.06 309.23 445.04 302.32 442.74 306.31 438.76 313.21 441.06",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.21 441.06 309.23 445.04 302.32 442.74 306.31 438.76 313.21 441.06",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.38 438.11 300.39 442.1 293.49 439.8 297.47 435.81 304.38 438.11",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.38 438.11 300.39 442.1 293.49 439.8 297.47 435.81 304.38 438.11",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.54 435.17 291.55 439.15 284.65 436.85 288.63 432.87 295.54 435.17",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.54 435.17 291.55 439.15 284.65 436.85 288.63 432.87 295.54 435.17",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.7 432.22 282.71 436.21 275.81 433.9 279.79 429.92 286.7 432.22",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.7 432.22 282.71 436.21 275.81 433.9 279.79 429.92 286.7 432.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.05 444 318.07 447.99 311.16 445.69 315.15 441.7 322.05 444",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.05 444 318.07 447.99 311.16 445.69 315.15 441.7 322.05 444",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,453.33v1.3a.6.6,0,0,0,.29-.13l6.66-6.67a.21.21,0,0,0,.07-.15V446.4a.19.19,0,0,1-.07.13l-6.66,6.67A.6.6,0,0,1,328,453.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.32,444.94v.47a.81.81,0,0,1-.36.63l-9.42,5.44a.83.83,0,0,1-.72,0L279.31,425.2a.78.78,0,0,1-.36-.62v-.47a.78.78,0,0,1,.36-.62l9.42-5.45a.83.83,0,0,1,.72,0L335,444.32A.78.78,0,0,1,335.32,444.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,444.32,289.45,418a.83.83,0,0,0-.72,0l-9.42,5.45a.22.22,0,0,0,0,.41l45.51,26.28a.83.83,0,0,0,.72,0l9.42-5.45A.22.22,0,0,0,335,444.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.18,450.26v1.3a.83.83,0,0,0,.36-.08L335,446a.81.81,0,0,0,.36-.63v-.47a.78.78,0,0,0-.29-.57c.13.11.1.27-.07.37l-9.42,5.43A.71.71,0,0,1,325.18,450.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,444.32,289.45,418a.83.83,0,0,0-.72,0l-9.42,5.44c-.2.12-.2.31,0,.42l45.51,26.28a.83.83,0,0,0,.72,0l9.42-5.45A.22.22,0,0,0,335,444.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.81 444.53 325.18 447.78 319.54 444.52 325.18 441.27 330.81 444.53",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.38 436.19 310.74 439.45 305.11 436.19 310.74 432.94 316.38 436.19",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.38 436.19 310.74 439.45 305.11 436.19 310.74 432.94 316.38 436.19",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.16 432.03 303.53 435.28 297.89 432.03 303.53 428.77 309.16 432.03",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.16 432.03 303.53 435.28 297.89 432.03 303.53 428.77 309.16 432.03",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.95 427.86 296.31 431.11 290.67 427.86 296.31 424.61 301.95 427.86",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.95 427.86 296.31 431.11 290.67 427.86 296.31 424.61 301.95 427.86",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.73 423.69 289.09 426.95 283.46 423.69 289.09 420.44 294.73 423.69",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.73 423.69 289.09 426.95 283.46 423.69 289.09 420.44 294.73 423.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.6 440.36 317.96 443.61 312.32 440.36 317.96 437.1 323.6 440.36",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.6 440.36 317.96 443.61 312.32 440.36 317.96 437.1 323.6 440.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.14,444.2c-.31.18-.31.47,0,.66a1.27,1.27,0,0,0,1.14,0c.32-.19.32-.48,0-.66A1.21,1.21,0,0,0,332.14,444.2Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.08,306.63,402.59,306l-.39,37.14h0c0,3.36,2.15,6.75,6.56,9.36,8.83,5.23,23.23,5.38,32.17.35,4.51-2.54,6.76-5.91,6.75-9.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.36,296.8c-8.93,5-9,13.35-.2,18.57s23.23,5.38,32.17.35,9-13.35.2-18.57S418.3,291.77,409.36,296.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.12,306.48a5.62,5.62,0,0,1-.32,1.78c-.69,2.13-2.55,4.11-5.44,5.74a33.7,33.7,0,0,1-30.19-.32c-2.8-1.66-4.63-3.66-5.27-5.74a5.45,5.45,0,0,1-.33-1.91c.05-2.77,2.08-5.44,5.77-7.5a33.66,33.66,0,0,1,30.19.33C444.17,301,446.15,303.71,446.12,306.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.8,308.26c-.69,2.13-2.55,4.11-5.44,5.74a33.7,33.7,0,0,1-30.19-.32c-2.8-1.66-4.63-3.66-5.27-5.74.69-2.13,2.54-4.11,5.44-5.72a30.64,30.64,0,0,1,15.12-3.44,31,31,0,0,1,15.07,3.76C443.33,304.2,445.13,306.18,445.8,308.26Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.36,314a18.54,18.54,0,0,0,2.07-1.36c-8.31,4.45-22.59,2.58-27-.92s-5.05-9.48,2.19-12.15a25.86,25.86,0,0,0-7.24,2.65c-2.9,1.61-4.75,3.59-5.44,5.72.64,2.08,2.47,4.08,5.27,5.74a33.7,33.7,0,0,0,30.19.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,320.54c1-.56,1.8-.09,1.78,1.06a4,4,0,0,1-1.82,3.09c-1,.56-1.8.09-1.79-1.06A4,4,0,0,1,435,320.54Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rulers--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Square--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--square--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.24,403.8l-37.86,21.86,37.86,21.85Zm-8.91,12.86v18l-15.59-9Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.24,403.8l-37.86,21.86,37.86,21.85Zm-8.91,12.86v18l-15.59-9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,405.54v40.24l-34.86-20.12,34.86-20.12m-6.91,30.85V414.93l-1.5.86-15.59,9-1.5.87,1.5.86,15.59,9,1.5.87m7.91-32.59-37.86,21.86,37.86,21.85V403.8Zm-8.91,30.86-15.59-9,15.59-9v18Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "248.24 403.8 214.15 425.22 248.24 447.51 210.38 425.66 248.24 403.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,425.47l.89.59,4,2.61-5.22-3,.33-.19m35.53-21.67-37.86,21.86,37.86,21.85-34.09-22.29,34.09-21.42Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "248.24 447.48 248.24 450.05 210.38 428.23 210.38 425.66 248.24 447.48",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.24 447.48 248.24 450.05 210.38 428.23 210.38 425.66 248.24 447.48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.38,427.39l35.86,20.67v.26l-35.86-20.67v-.26m-1-1.73v2.57l37.86,21.82v-2.57l-37.86-21.82Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "223.74 425.66 225.96 426.94 239.33 419.23 239.33 416.66 223.74 425.66",
    style: {
      fill: "#242424"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--square--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--square--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.78,452.53,203.7,429.39,152.49,459Zm-20-3.85-44.53,2.57,24.49-14.14Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.78,452.53,203.7,429.39,152.49,459Zm-20-3.85-44.53,2.57,24.49-14.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,430.55l36.75,21.22-83.71,5.89,47-27.11m-28.64,21.94,4.21-.24,44.53-2.57,3.34-.2-2.9-1.67-20-11.57-.5-.29-.5.29-24.49,14.14-3.65,2.11m28.64-23.1L152.49,459l91.29-6.43L203.7,429.39Zm-24.49,21.86,24.49-14.14,20,11.57-44.53,2.57Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "203.7 429.39 159 457.16 243.78 452.54 152.49 458.96 203.7 429.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.7 429.39 152.49 458.96 243.78 452.54 159 457.16 203.7 429.39 203.7 429.39",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "203.7 437.11 223.74 448.68 219.69 448.91 203.7 439.68 203.7 437.11",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.7 437.11 223.74 448.68 219.69 448.91 203.7 439.68 203.7 437.11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.7,438.84l15.65,9-.42,0-15.23-8.8v-.26m-1-1.73v2.57l16,9.23,4.05-.23-20-11.57Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "243.78 452.53 243.78 455.11 152.49 461.65 152.49 458.96 243.78 452.54",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "243.78 452.53 243.78 455.11 152.49 461.65 152.49 458.96 243.78 452.54",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.21 451.25 184.16 450.96 203.7 439.68 203.7 437.11 179.21 451.25",
    style: {
      fill: "#242424"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tools-box--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-box--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-box--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60.68 367.3 60.68 337.21 23.46 315.72 27.18 347.96 60.68 367.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.68 367.3 116.51 335.06 120.24 302.83 60.68 337.21 60.68 367.3",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.14,309.28a1.66,1.66,0,0,1,1-1.38l58.52-33.78a5.25,5.25,0,0,1,4.76,0L121.58,295a1.66,1.66,0,0,1,1,1.37V305a1.64,1.64,0,0,1-1,1.38L63.06,340.14a5.25,5.25,0,0,1-4.76,0L22.12,319.25a1.65,1.65,0,0,1-1-1.37Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.12,307.9l38.56-22.26v55.07a4.87,4.87,0,0,1-2.38-.57L22.12,319.25a1.65,1.65,0,0,1-1-1.37v-8.6A1.66,1.66,0,0,1,22.12,307.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68,285.64l20-11.52a5.25,5.25,0,0,1,4.76,0L121.58,295a1.66,1.66,0,0,1,1,1.37V305a1.64,1.64,0,0,1-1,1.38L63.06,340.14a4.82,4.82,0,0,1-2.38.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,331.54,22.12,310.65c-1.31-.76-1.31-2,0-2.75l58.52-33.78a5.25,5.25,0,0,1,4.76,0L121.58,295c1.31.76,1.31,2,0,2.75L63.06,331.54A5.25,5.25,0,0,1,58.3,331.54Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.93,297.46c1,.59,1,1.59-.12,2.22l-40.7,23.49a4.2,4.2,0,0,1-3.84.07c-1-.59-1-1.58.12-2.22l40.7-23.49A4.23,4.23,0,0,1,110.93,297.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,323.17a4.2,4.2,0,0,1-3.84.07,1,1,0,0,1-.2-.14,2,2,0,0,1,.32-.22l40.7-23.5a4.26,4.26,0,0,1,3.84-.07,1,1,0,0,1,.2.14,2,2,0,0,1-.32.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.16,280.27c1,.59,1,1.58-.12,2.21L40.34,306a4.25,4.25,0,0,1-3.85.07c-1-.59-1-1.59.13-2.22l40.69-23.49A4.22,4.22,0,0,1,81.16,280.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34,306a4.25,4.25,0,0,1-3.85.07l-.2-.14a2.13,2.13,0,0,1,.33-.23l40.69-23.49a4.25,4.25,0,0,1,3.85-.07l.2.14a2.57,2.57,0,0,1-.32.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93,308.21c-1,.59-1,1.58.12,2.22l14.65,8.45a4.28,4.28,0,0,0,3.85.07c1-.6,1-1.59-.13-2.22l-14.65-8.45A4.2,4.2,0,0,0,43.93,308.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7,318.88a4.28,4.28,0,0,0,3.85.07l.2-.15a2.1,2.1,0,0,0-.33-.22l-14.65-8.45a4.23,4.23,0,0,0-3.84-.07,1,1,0,0,0-.2.14l.32.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.49,312.5c-1,.59-1,1.59.13,2.22l14.65,8.45a4.26,4.26,0,0,0,3.84.07c1-.59,1-1.59-.12-2.22l-14.65-8.45A4.28,4.28,0,0,0,36.49,312.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.27,323.17a4.26,4.26,0,0,0,3.84.07,1.73,1.73,0,0,0,.2-.14,2.62,2.62,0,0,0-.32-.23l-14.65-8.45a4.28,4.28,0,0,0-3.85-.07l-.2.14a2.13,2.13,0,0,0,.33.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.59,282.42c-1,.59-1,1.59.12,2.22l14.66,8.45a4.26,4.26,0,0,0,3.84.07c1-.59,1-1.59-.12-2.22l-14.65-8.45A4.28,4.28,0,0,0,88.59,282.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37,293.09a4.26,4.26,0,0,0,3.84.07,1.43,1.43,0,0,0,.2-.14,2.62,2.62,0,0,0-.32-.23l-14.65-8.45a4.28,4.28,0,0,0-3.85-.07l-.2.14a2.62,2.62,0,0,0,.32.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.16,286.71c-1,.6-1,1.59.12,2.22l14.65,8.45a4.2,4.2,0,0,0,3.84.07c1-.59,1-1.58-.12-2.22L85,286.78A4.26,4.26,0,0,0,81.16,286.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.93,297.38a4.2,4.2,0,0,0,3.84.07,1,1,0,0,0,.2-.14,2,2,0,0,0-.32-.23L85,288.64a4.23,4.23,0,0,0-3.84-.08l-.2.15a2,2,0,0,0,.32.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,301v8.31l3.72,2.15,3.72-2.15V303a4.39,4.39,0,0,1,2-3.43l9.18-5.31,1.74-1c1.09-.63,2-.12,2,1.15v6.3L83,298.53v-8.31a4,4,0,0,0,0-.5,2.2,2.2,0,0,0-.06-.37,1.72,1.72,0,0,0-.11-.42c0-.11-.08-.22-.12-.33a2.16,2.16,0,0,0-.18-.3,1.79,1.79,0,0,0-.2-.26,1.19,1.19,0,0,0-.23-.22h0a1.17,1.17,0,0,0-.26-.17.39.39,0,0,0-.11-.06l-3.59-2.07a2.75,2.75,0,0,0-2.79.27l-14.4,8.31A8.76,8.76,0,0,0,57,301Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.57,294.23h0v4.29l3.72,2.15v-6.3c0-1.27-.89-1.78-2-1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.69,303.11v8.32l3.72-2.15V303a4.39,4.39,0,0,1,2-3.43l9.18-5.3h0l1.74-1c1.09-.63,2-.12,2,1.15v6.3L83,298.54v-8.32a4,4,0,0,0,0-.5,2.2,2.2,0,0,0-.06-.37,1.72,1.72,0,0,0-.11-.42c0-.11-.08-.22-.12-.33a2.16,2.16,0,0,0-.18-.3,1.79,1.79,0,0,0-.2-.26,1.19,1.19,0,0,0-.23-.22h0a1.17,1.17,0,0,0-.26-.17.39.39,0,0,0-.11-.06,2.85,2.85,0,0,0-2.66.35l-14.4,8.31A8.77,8.77,0,0,0,60.69,303.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.29 339.36 77.92 338.57 74.2 340.72 75.57 341.51 79.29 339.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.57 341.51 74.2 359.5 74.19 340.72 75.57 341.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.29 339.36 77.92 357.35 78.37 357.13 79.29 339.36",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.14 342.87 49.52 342.07 53.24 344.22 51.86 345.01 48.14 342.87",
    style: {
      fill: "#455a64"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "48.14 342.87 49.52 360.85 49.06 360.64 48.14 342.87"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 334.27 34.63 333.48 38.35 335.62 36.97 336.42 33.25 334.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.24 363 51.86 345.01 53.24 344.22 53.24 363",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.35 335.62 38.35 354.4 36.97 336.42 38.35 335.62",
    style: {
      fill: "#37474f"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "33.25 334.27 34.63 352.25 34.17 352.04 33.25 334.27"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "105.35 324.32 103.97 323.53 100.25 325.67 101.63 326.47 105.35 324.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.63 326.47 100.25 344.45 100.25 325.67 101.63 326.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.35 324.32 103.97 342.31 104.43 342.09 105.35 324.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.19 336.31 72.2 332.01 79.65 327.71 80.89 328.43 80.88 332.72 73.43 337.02 72.19 336.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.89 328.43 80.88 332.72 73.43 337.02 73.44 332.72 80.89 328.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.44 332.72 72.2 332.01 72.19 336.31 73.43 337.02 73.44 332.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.45 321.16 98.46 316.86 105.91 312.56 107.15 313.28 107.14 317.58 99.69 321.88 98.45 321.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.15 313.28 107.14 317.58 99.69 321.88 99.7 317.58 107.15 313.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.7 317.58 98.46 316.86 98.45 321.16 99.69 321.88 99.7 317.58",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,119.83a2,2,0,0,1-1.8-1.16l-5.51-12C223,105.09,208.55,97,202.15,84a42.86,42.86,0,0,1,2.75-43.38c8.5-13,25.54-21.33,43.43-21.33,19.07,0,33.2,5.74,43.2,17.56h0c12.26,14.49,12.87,35.28,6.38,47-7.66,13.85-20.94,21.32-40.61,22.83l-5.5,11.94A2,2,0,0,1,250,119.83Zm-1.67-99.51c-17.56,0-34.28,8.19-42.59,20.88A41.89,41.89,0,0,0,203,83.59c8.47,17.19,28.71,21.26,40,22.15l.29,0,5.75,12.48a1,1,0,0,0,1.79,0l5.75-12.47.3,0c19.75-1.47,32.48-8.56,40.09-22.34,6.19-11.2,5.55-31.92-6.26-45.89C281,26,267.08,20.32,248.33,20.32Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.48,63.41a2.38,2.38,0,0,0-.76-2l-30-27.86a2.69,2.69,0,0,0-3.48,0l-30,27.86a2.44,2.44,0,0,0,1.64,4.22h6.28V87.22a3.19,3.19,0,0,0,3.18,3.19h41.24a3.19,3.19,0,0,0,3.18-3.19V65.64h6.28A2.39,2.39,0,0,0,282.48,63.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.55,69.1V64.36a.61.61,0,0,0-.54-.58l-4.22-.46a.92.92,0,0,1-.71-.63,13.11,13.11,0,0,0-.94-2.29.94.94,0,0,1-.06-.91L264.89,56c.15-.18,0-.56-.25-.84l-3.05-3.06c-.28-.28-.66-.39-.84-.25l-3.51,2.82a1,1,0,0,1-.92-.07,14.76,14.76,0,0,0-2.28-.94.9.9,0,0,1-.63-.7l-.47-4.22a.6.6,0,0,0-.57-.54h-4.74a.58.58,0,0,0-.57.48L246.59,53a.77.77,0,0,1-.5.6,14.18,14.18,0,0,0-2.63,1.1,1,1,0,0,1-.93-.24L239.48,52c-.31-.25-.69-.32-.85-.15l-3.49,3.49c-.16.16-.1.54.15.85l2.45,3a1,1,0,0,1,.23.93,14.18,14.18,0,0,0-1.1,2.63.76.76,0,0,1-.6.5l-4.34.47a.57.57,0,0,0-.48.57V69.1a.6.6,0,0,0,.54.57l4.22.46a1,1,0,0,1,.71.64,13,13,0,0,0,.94,2.28,1,1,0,0,1,.06.92l-2.81,3.51c-.15.18,0,.55.25.84l3,3.05c.28.28.66.4.84.25l3.51-2.81a1,1,0,0,1,.92.06,13,13,0,0,0,2.28.94.92.92,0,0,1,.63.71l.47,4.22a.6.6,0,0,0,.57.54h4.74a.58.58,0,0,0,.57-.49l.47-4.33a.77.77,0,0,1,.5-.61,13.5,13.5,0,0,0,2.63-1.09,1,1,0,0,1,.93.23l3,2.45c.31.24.69.31.85.15l3.49-3.49c.16-.16.1-.55-.15-.85l-2.45-3a1,1,0,0,1-.23-.93,14,14,0,0,0,1.1-2.64.75.75,0,0,1,.6-.49l4.34-.47A.58.58,0,0,0,268.55,69.1ZM250,74.74a8,8,0,1,1,8-8A8,8,0,0,1,250,74.74Z",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.acbd86792ff83a2ccdf2db8bf4f343bd.svg";
export { ForwardRef as ReactComponent };